/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';
import * as Yup from 'yup';
import Text from '../components/shared/Text';
import QuestionReference from '../components/GoalsFlow/QuestionReference';
import { References } from '../components/GoalsFlow/styles';
import Icon from '../components/shared/Icon';

import { bankInformationFrontEnd } from './debtCalculator';
import { palette } from './styles';

// TODO: Describe in a comment what each one of these do & where they're used

export const questionTypes = {
  NUMERIC: 'number',
  YESNO: 'yes-no',
  SELECTION: 'select',
};

export const FinancialInstrument = {
  inputName: 'financialInstrument',
  type: questionTypes.SELECTION,
  startText: '',
  endText: '',
  placeholder: 'CETES',
  answers: [
    {
      label: 'CETES',
      value: 'cetes',
    },
    {
      label: 'Banco',
      value: 'banco',
    },
    {
      label: 'Fondo de Ahorro',
      value: 'fondo_de_ahorro',
    },
  ],
};

export const testQuestions = [
  {
    inputName: 'hasBankAccount',
    base: true,
    value: false,
    type: questionTypes.YESNO,
    startText: '¿Tienes cuenta bancaria?',
    maxQuestions: 3,
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
        // 3 Extra Questions
        extraQuestions: [
          {
            inputName: 'savingsSi',
            type: questionTypes.SELECTION,
            startText: 'Uso mi cuenta de',
            endText: 'para guardar mis ahorros.',
            answers: [
              {
                label: 'Bancomer',
                value: 'bancomer',
              },
              {
                label: 'Santander',
                value: 'santander',
              },
              {
                label: 'HSBC',
                value: 'hsbc',
              },
            ],
          },
          {
            inputName: '2genericQuestion2',
            value: null,
            type: questionTypes.NUMERIC,
            pattern: '[0-9]*',
            prepend: '$',
            startText: '2genericQuestion2 ',
            endText: 'all gucci',
            placeholder: '',
            maxDigits: 7,
            inputMaxWidth: 5,
          },
          {
            inputName: '2genericQuestion3',
            value: null,
            type: questionTypes.NUMERIC,
            pattern: '[0-9]*',
            prepend: '$',
            startText: '2genericQuestion3 ',
            endText: 'all gucci',
            placeholder: '',
            maxDigits: 7,
            inputMaxWidth: 5,
          },
        ],
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
        // 1 Extra Question
        extraQuestions: [
          {
            inputName: 'savingsNo',
            type: questionTypes.SELECTION,
            startText: 'Uso mi cuenta de',
            endText: 'para el retiro.',
            answers: [
              {
                label: 'Bancomer',
                value: 'bancomer',
                extraQuestions: [
                  {
                    inputName: 'xgeneric1',
                    value: null,
                    type: questionTypes.NUMERIC,
                    pattern: '[0-9]*',
                    prepend: '$',
                    startText: 'xg1 ',
                    endText: 'g1after',
                    placeholder: '',
                    maxDigits: 7,
                    inputMaxWidth: 5,
                  },
                ],
              },
              {
                label: 'Santander',
                value: 'santander',
              },
              {
                label: 'HSBC',
                value: '1hsbc',
              },
              {
                label: 'Santander',
                value: '1santander',
              },
              {
                label: 'HSBC',
                value: '2hsbc',
              },
              {
                label: 'Santander',
                value: '2santander',
              },
              {
                label: 'HSBC',
                value: '3hsbc',
              },
            ],
          },
        ],
      },
      {
        label: 'Tal Vez',
        value: 2,
      },
      {
        label: 'wabe',
        value: 3,
      },
      {
        label: 'zabe',
        value: 4,
      },
    ],
  },
  {
    inputName: 'firstQuestion',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    startText: 'Primera pregunta tiene',
    endText: 'likes',
    placeholder: '10',
    maxDigits: 7,
    inputMaxWidth: 5,
    maxQuestions: 4,
    condition: (x) => {
      const inputInt = x.replace(/,/g, '');
      let temp = {};
      if (inputInt === '') {
        temp = {
          value: 0,
          extraQuestions: [],
        };
      } else if (inputInt >= 0 && inputInt < 5) {
        temp = {
          value: 1,
          // 3 Extra Questions
          extraQuestions: [
            {
              inputName: '1generic1',
              value: null,
              type: questionTypes.NUMERIC,
              pattern: '[0-9]*',
              prepend: '$',
              startText: 'g1 ',
              endText: 'g1after',
              placeholder: '',
              maxDigits: 7,
              inputMaxWidth: 5,
            },
            {
              inputName: '1generic2',
              value: null,
              type: questionTypes.NUMERIC,
              pattern: '[0-9]*',
              prepend: '$',
              startText: 'g2 ',
              endText: 'g2after',
              placeholder: '',
              maxDigits: 7,
              inputMaxWidth: 5,
            },
            {
              inputName: '1generic3',
              value: null,
              type: questionTypes.NUMERIC,
              pattern: '[0-9]*',
              prepend: '$',
              startText: 'g3 ',
              endText: 'g3after',
              placeholder: '',
              maxDigits: 7,
              inputMaxWidth: 5,
            },
          ],
        };
      } else if (inputInt >= 5 && inputInt < 10) {
        temp = {
          value: 2,
          // 2 Extra Questions
          extraQuestions: [
            {
              inputName: '2generic1',
              value: null,
              type: questionTypes.NUMERIC,
              pattern: '[0-9]*',
              prepend: '$',
              startText: 'g1 ',
              endText: 'g1after',
              placeholder: '',
              maxDigits: 7,
              inputMaxWidth: 5,
            },
            {
              inputName: '2generic2',
              value: null,
              type: questionTypes.NUMERIC,
              pattern: '[0-9]*',
              prepend: '$',
              startText: 'g2 ',
              endText: 'g2after',
              placeholder: '',
              maxDigits: 7,
              inputMaxWidth: 5,
            },
          ],
        };
      } else if (inputInt >= 10) {
        temp = {
          value: 3,
          // 4 Extra Questions
          extraQuestions: [
            {
              inputName: '3generic1',
              value: null,
              type: questionTypes.NUMERIC,
              pattern: '[0-9]*',
              prepend: '$',
              startText: 'g1 ',
              endText: 'g1after',
              placeholder: '',
              maxDigits: 7,
              inputMaxWidth: 5,
            },
            {
              inputName: '3generic2',
              value: null,
              type: questionTypes.NUMERIC,
              pattern: '[0-9]*',
              prepend: '$',
              startText: 'g2 ',
              endText: 'g2after',
              placeholder: '',
              maxDigits: 7,
              inputMaxWidth: 5,
            },
            {
              inputName: '3generic3',
              value: null,
              type: questionTypes.NUMERIC,
              pattern: '[0-9]*',
              prepend: '$',
              startText: 'g3 ',
              endText: 'g3after',
              placeholder: '',
              maxDigits: 7,
              inputMaxWidth: 5,
            },
            {
              inputName: '3generic4',
              value: null,
              type: questionTypes.NUMERIC,
              pattern: '[0-9]*',
              prepend: '$',
              startText: 'g4 ',
              endText: 'g4after',
              placeholder: '',
              maxDigits: 7,
              inputMaxWidth: 5,
            },
          ],
        };
      } else {
        temp = {
          value: 0,
          extraQuestions: [],
        };
      }
      return temp;
    },
  },
  {
    inputName: 'fQuestion',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'fQuestiontext ',
    endText: 'wazabe',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,
  },
  {
    inputName: 'thirdQuestion',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'thirdQuestion ',
    endText: 'all gucci',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,
  },
  {
    inputName: 'amountOfSavings',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'ULTIMA PREGUNTA!',
    endText: 'hasta ahora baby...',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,
  },
];

export const questionsDitchedTest = [
  {
    inputName: 'first',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    startText: 'Primera pregunta tiene',
    endText: 'likes',
    placeholder: '10',
    maxDigits: 7,
    inputMaxWidth: 5,
    maxQuestions: 4,
    condition: (x) => {
      const inputInt = x.replace(/,/g, '');

      let temp = {};
      if (inputInt === '') {
        temp = {
          value: 0,
          extraQuestions: [],
        };
      } else {
        switch (Number(x)) {
          case 1:
            temp = {
              value: 1,
              // 2 Extra Questions
              extraQuestions: [
                {
                  inputName: '1a',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '1a',
                  endText: '1a',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
                {
                  inputName: '2a',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '2a',
                  endText: '2a',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
              ],
            };
            break;
          case 2:
            temp = {
              value: 2,
              // 4 Extra Questions
              extraQuestions: [
                {
                  inputName: '1b',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '1b',
                  endText: '1b',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
                {
                  inputName: '2b',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '2b',
                  endText: '2b',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
                {
                  inputName: '3b',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '3b',
                  endText: '3b',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
                {
                  inputName: '4b',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '4b',
                  endText: '4b',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
              ],
            };
            break;
          case 3:
            temp = {
              value: 3,
              // 1 Extra Questions
              extraQuestions: [
                {
                  inputName: '1c',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '1c',
                  endText: '1c',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
              ],
            };
            break;
          default:
            temp = {
              value: 0,
              extraQuestions: [],
            };
            break;
        }
      }
      return temp;
    },
  },
  {
    inputName: 'second',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    startText: 'Primera pregunta tiene',
    endText: 'likes',
    placeholder: '10',
    maxDigits: 7,
    inputMaxWidth: 5,
    maxQuestions: 3,
    condition: (x) => {
      const inputInt = x.replace(/,/g, '');
      let temp = {};
      if (inputInt === '') {
        temp = {
          value: 0,
          extraQuestions: [],
        };
      } else {
        switch (Number(x)) {
          case 1:
            temp = {
              value: 1,
              // 2 Extra Questions
              extraQuestions: [
                {
                  inputName: '1d',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '1d',
                  endText: '1d',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
                {
                  inputName: '2d',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '2d',
                  endText: '2d',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
              ],
            };
            break;
          case 2:
            temp = {
              value: 2,
              // 3 Extra Questions
              extraQuestions: [
                {
                  inputName: '1e',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '1e',
                  endText: '1e',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
                {
                  inputName: '2e',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '2e',
                  endText: '2e',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
                {
                  inputName: '3e',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '3e',
                  endText: '3e',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
              ],
            };
            break;
          case 3:
            temp = {
              value: 3,
              // 1 Extra Questions
              extraQuestions: [
                {
                  inputName: '1f',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '1f',
                  endText: '1f',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
              ],
            };
            break;
          default:
            temp = {
              value: 0,
              extraQuestions: [],
            };
            break;
        }
      }
      return temp;
    },
  },
  {
    inputName: 'third',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    startText: 'Primera pregunta tiene',
    endText: 'likes',
    placeholder: '10',
    maxDigits: 7,
    inputMaxWidth: 5,
    maxQuestions: 3,
    condition: (x) => {
      const inputInt = x.replace(/,/g, '');
      let temp = {};
      if (inputInt === '') {
        temp = {
          value: 0,
          extraQuestions: [],
        };
      } else {
        switch (Number(x)) {
          case 1:
            temp = {
              value: 1,
              // 2 Extra Questions
              extraQuestions: [
                {
                  inputName: '1w',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '1w',
                  endText: '1w',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
                {
                  inputName: '2w',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '2w',
                  endText: '2w',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
              ],
            };
            break;
          case 2:
            temp = {
              value: 2,
              // 3 Extra Questions
              extraQuestions: [
                {
                  inputName: '1x',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '1x',
                  endText: '1x',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
                {
                  inputName: '2x',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '2x',
                  endText: '2x',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
                {
                  inputName: '3x',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '3x',
                  endText: '3x',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
              ],
            };
            break;
          case 3:
            temp = {
              value: 3,
              // 1 Extra Questions
              extraQuestions: [
                {
                  inputName: '1y',
                  value: null,
                  type: questionTypes.NUMERIC,
                  pattern: '[0-9]*',
                  startText: '1y',
                  endText: '1y',
                  placeholder: '',
                  maxDigits: 7,
                  inputMaxWidth: 5,
                },
              ],
            };
            break;
          default:
            temp = {
              value: 0,
              extraQuestions: [],
            };
            break;
        }
      }
      return temp;
    },
  },
];

/*
[
  {
    label: 'Bancomer',
    value: `bancomer${x}`,
    extraQuestions: [
      {
        inputName: `type_of_card_${x}`,
        type: questionTypes.SELECTION,
        startText: 'Mi tarjeta es ',
        endText: '',
        answers: [
          {
            label: 'Clasica',
            value: `clasica_${x}`,
          },
          {
            label: 'Gold',
            value: `gold_${x}`,
          },
          {
            label: 'Platino',
            value: `platino_${x}`,
          },
        ],
      },
    ],
  },
  {
    label: 'Santander',
    value: `santander_${x}`,
  },
  {
    label: 'HSBC',
    value: `hsbc_${x}`,
  },
]
*/

function generateExpenseQuestion(n) {
  const questions = [
    {
      inputName: `exp_${n}_amount`,
      type: questionTypes.NUMERIC,
      startText: 'Gasto',
      placeholder: '1,000',
      prepend: '$',
      endText: ` al mes en gasto obligatorio extra #${n}`,
      validation: Yup.string()
        .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
        .required('Este es un campo requerido'),
    },
  ];
  return questions;
}

function generateCardAnswers(map, x) {
  const cardAnswers = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const [k, v] of map.entries()) {
    cardAnswers.push({
      label: v.name,
      value: `${k}${x}`,
    });
  }

  return cardAnswers;
}

function generateBankAnswers(map, x) {
  const bankAnswers = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const [k, v] of map.entries()) {
    bankAnswers.push({
      label: v.name,
      value: `${k}${x}`,
      extraQuestions: [
        {
          inputName: `type_of_card_${x}`,
          value: null,
          type: questionTypes.SELECTION,
          startText: 'Mi tarjeta es ',
          placeholder: 'Tipo',
          endText: '',
          validation: Yup.string().required('Este es un campo requerido'),
          answers: generateCardAnswers(v.cards, x),
        },
      ],
    });
  }
  return bankAnswers;
}

function generateChildrenAnswers() {
  const answers = [];
  const inputs = generateChildrenInputs(30);

  for (let i = 1; i <= 30; i += 1) {
    answers.push({ label: i, value: i, extraQuestions: inputs.slice(0, i) });
  }

  return answers;
}

const inputMap = new Map([
  // Retirement tool
  [
    'saving_period',
    {
      startText: 'Ahorro para el retiro cada ',
      type: questionTypes.YESNO,
      label: 'Ahorro para el retiro cada',
    },
  ],
  [
    'extra_afore_saving_period',
    {
      startText: 'Realizo aportaciones complementarias cada ',
      type: questionTypes.YESNO,
      label: 'Ahorro para el retiro cada ',
    },
  ],
  [
    'ppr_saving_period',
    {
      startText: 'Ahorro en mi Plan Personal para el Retiro cada ',
      type: questionTypes.YESNO,
      label: 'Ahorro para el retiro cada',
    },
  ],
  [
    'bw_savings',
    {
      label: '',
      endText: ' para el retiro',
      type: questionTypes.NUMERIC,
      startText: 'Cada quincena ahorro ',
    },
  ],
  [
    'mo_savings',
    {
      label: '',
      endText: ' para el retiro',
      type: questionTypes.NUMERIC,
      startText: 'Cada mes ahorro ',
    },
  ],
  [
    'ppr_bw_savings',
    {
      label: '',
      endText: ' a mi Plan Personal para el Retiro',
      type: questionTypes.NUMERIC,
      startText: 'Cada quincena ahorro ',
    },
  ],
  [
    'ppr_mo_savings',
    {
      label: '',
      endText: ' a mi Plan Personal para el Retiro',
      type: questionTypes.NUMERIC,
      startText: 'Cada mes ahorro ',
    },
  ],
  [
    'extra_afore_bw_savings',
    {
      label: '',
      endText: ' a mi AFORE',
      type: questionTypes.NUMERIC,
      startText: 'Cada quincena aporto ',
    },
  ],
  [
    'extra_afore_mo_savings',
    {
      label: '',
      endText: ' a mi AFORE',
      type: questionTypes.NUMERIC,
      startText: 'Cada mes aporto ',
    },
  ],
  [
    'salary_recipt',
    {
      label: '¿Tienes recibos de nómina en los que te descuentan impuestos?',
      startText: '¿Tienes recibos de nómina en los que te descuentan impuestos?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'has_salary_recipts',
    {
      label: '¿Has tenido recibos de nómina en los que te descuentan impuestos?',
      startText: '¿Has tenido recibos de nómina en los que te descuentan impuestos?',
      type: questionTypes.YESNO,
    },
  ],
  // personalInfo
  [
    'age',
    {
      label: 'Edad',
      startText: 'Tengo',
      endText: ' años',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'sex',
    {
      label: 'Sexo',
      startText: 'Soy...',
      endText: '',
      type: questionTypes.YESNO,
    },
  ],
  [
    'zipcode',
    {
      label: 'Código postal',
      startText: 'Mi código postal es ',
    },
  ],
  [
    'social_security',
    {
      label: 'Cotizas en IMMS o ISSSTE',
      startText: '¿Cotizas en el IMSS o el ISSSTE?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'has_social_security',
    {
      label: '¿Has cotizado en el IMSS o ISSSTE?',
      startText: '¿Has cotizado en el IMSS o ISSSTE?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'law_97',
    {
      label: 'Empezaste a trabajar después de 1997',
      type: questionTypes.YESNO,
      startText: '¿Comenzaste a trabajar formalmente después de 1997?',
    },
  ],
  [
    'does_deductions',
    {
      label: 'Realizas deducciones fiscales',
      startText: '¿Usualmente realizas deducciones fiscales?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'congrats_pension',
    {
      startText:
        '¡Felicidades! Tu podrás pensionarte, y nosotros sabemos cómo maximizar tu pensión.',
      label: 'Felicidades pensión',
      type: questionTypes.YESNO,
    },
  ],
  [
    'has_children',
    {
      label: '¿Tienes hijos?',
      type: questionTypes.YESNO,
      startText: '¿Tienes hijos?',
    },
  ],
  [
    'child_0',
    {
      label: 'Edad de tu primer hijo',
    },
  ],
  [
    'child_1',
    {
      label: 'Edad de tu segundo hijo',
    },
  ],
  [
    'child_2',
    {
      label: 'Edad de tu tercer hijo',
    },
  ],
  [
    'child_3',
    {
      label: 'Edad de tu cuarto hijo',
    },
  ],
  [
    'child_4',
    {
      label: 'Edad de tu quinto hijo',
    },
  ],
  [
    'child_5',
    {
      label: 'Edad de tu sexto hijo',
    },
  ],
  [
    'child_6',
    {
      label: 'Edad de tu séptimo hijo',
    },
  ],
  [
    'child_7',
    {
      label: 'Edad de tu octavo hijo',
    },
  ],
  [
    'child_8',
    {
      label: 'Edad de tu noveno hijo',
    },
  ],
  [
    'child_9',
    {
      label: 'Edad de tu décimo hijo',
    },
  ],
  [
    'child_10',
    {
      label: 'Edad de tu undécimo hijo',
    },
  ],
  [
    'child_11',
    {
      label: 'Edad de tu decimosegundo hijo',
    },
  ],
  [
    'child_12',
    {
      label: 'Edad de tu decimotercer hijo',
    },
  ],
  [
    'child_13',
    {
      label: 'Edad de tu decimocuarto hijo',
    },
  ],
  [
    'child_14',
    {
      label: 'Edad de tu decimoquinto hijo',
    },
  ],
  [
    'child_15',
    {
      label: 'Edad de tu decimosexto hijo',
    },
  ],
  [
    'child_16',
    {
      label: 'Edad de tu decimoséptimo hijo',
    },
  ],
  [
    'child_17',
    {
      label: 'Edad de tu decimoctavo hijo',
    },
  ],
  [
    'child_18',
    {
      label: 'Edad de tu decimonoveno hijo',
    },
  ],
  [
    'child_19',
    {
      label: 'Edad de tu vigésimo hijo',
    },
  ],
  [
    'child_20',
    {
      label: 'Edad de tu vigesimoprimer hijo',
    },
  ],
  [
    'child_21',
    {
      label: 'Edad de tu vigesimosegundo hijo',
    },
  ],
  [
    'child_22',
    {
      label: 'Edad de tu vigesimotercer hijo',
    },
  ],
  [
    'child_23',
    {
      label: 'Edad de tu vigesimocuarto hijo',
    },
  ],
  [
    'child_24',
    {
      label: 'Edad de tu vigesimoquinto hijo',
    },
  ],
  [
    'child_25',
    {
      label: 'Edad de tu vigesimosexto hijo',
    },
  ],
  [
    'child_26',
    {
      label: 'Edad de tu vigesimoséptimo hijo',
    },
  ],
  [
    'child_27',
    {
      label: 'Edad de tu vigesimoctavo hijo',
    },
  ],
  [
    'child_28',
    {
      label: 'Edad de tu vigesimonoveno hijo',
    },
  ],
  [
    'child_29',
    {
      label: 'Edad de tu trigésimo hijo',
    },
  ],
  [
    'children',
    {
      type: questionTypes.SELECTION,
      startText: 'Tengo ',
      endText: 'hijos',
      label: 'Número de hijos',
    },
  ],
  // debt
  [
    'credit_card_payment',
    {
      startText: 'Pago ',
      endText: 'pesos al mes en tarjetas de crédito',
      label: 'Pago en tarjetas de crédito',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'pays_credit_card_on_time',
    {
      startText: 'Liquido el total del saldo de mi tarjeta de crédito cada fecha de corte',
      label: 'Pago a tiempo mi tarjeta de crédito',
      type: questionTypes.YESNO,
    },
  ],
  [
    'credit_card_owed',
    {
      label: 'Deuda de tarjetas de crédito',
      endText: 'de tarjetas de crédito',
      startText: 'Debo ',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'credit_car_payment',
    {
      startText: 'Pago ',
      endText: 'pesos al mes en crédito automotriz',
      label: 'Pago en crédito automotriz',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'credit_car_owed',
    {
      label: 'Deuda de crédito automotriz',
      endText: 'en crédito automotriz',
      startText: 'Debo ',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'credit_home_payment',
    {
      startText: 'Pago ',
      endText: 'pesos al mes en crédito hipotecario',
      label: 'Pago en crédito hipotecario',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'credit_home_owed',
    {
      label: 'Deuda de crédito hipotecario',
      endText: 'en crédito hipotecario',
      startText: 'Debo ',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'credit_personal_payment',
    {
      startText: 'Pago ',
      endText: 'pesos al mes en crédito personal',
      label: 'Pago en crédito personal',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'credit_personal_owed',
    {
      label: 'Deuda de crédito personal',
      endText: 'en crédito personal',
      startText: 'Debo ',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'credit_school_payment',
    {
      startText: 'Pago ',
      endText: 'pesos al mes en crédito estudiantil',
      label: 'Pago en crédito estudiantil',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'credit_school_owed',
    {
      label: 'Deuda de crédito estudiantil',
      endText: 'en crédito estudiantil',
      startText: 'Debo ',
      type: questionTypes.NUMERIC,
    },
  ],
  // expenses
  [
    'total_income',
    {
      label: 'Ingreso después de impuestos',
      type: questionTypes.NUMERIC,
      startText: 'Mi ingreso mensual después de impuestos es ',
    },
  ],
  [
    'rents',
    {
      startText: '¿Rentas depa/casa?',
      type: questionTypes.YESNO,
      label: '¿Rentas depa/casa?',
    },
  ],
  [
    'rent_exp',
    {
      type: questionTypes.NUMERIC,
      startText: 'Gasto ',
      endText: 'al mes en renta',
      label: 'Gasto de renta',
    },
  ],
  [
    'has_mortgage_exp',
    {
      startText: '¿Pagas hipoteca?',
      type: questionTypes.YESNO,
      label: '¿Pagas hipoteca?',
    },
  ],
  [
    'mortgage_exp',
    {
      type: questionTypes.NUMERIC,
      startText: 'Gasto ',
      endText: 'al mes en hipoteca',
      label: 'Gasto de renta',
    },
  ],
  [
    'services_exp',
    {
      type: questionTypes.NUMERIC,
      startText: 'Gasto ',
      endText: 'al mes en servicios',
      label: 'Gasto de servicios',
    },
  ],
  [
    'phone_exp',
    {
      label: 'Gasto de teléfono',
      type: questionTypes.NUMERIC,
      startText: 'Gasto ',
      endText: 'al mes en plan o recargas de teléfono celular',
    },
  ],
  [
    'groceries_exp',
    {
      label: 'Gasto de despensa',
      type: questionTypes.NUMERIC,
      startText: 'Gasto ',
      endText: 'al mes en despensa',
    },
  ],
  [
    'pays_gas',
    {
      label: '¿Gastas en gasolina?',
      startText: '¿Gastas en gasolina?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'gas_amount',
    {
      label: 'Gasto en gasolina',
      startText: 'Gasto aprox. ',
      endText: ' al mes en gasolina',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'pays_uber',
    {
      label: '¿Sueles moverte en taxi/Uber?',
      startText: '¿Sueles moverte en taxi/Uber?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'uber_amount',
    {
      label: 'Gasto en gasolina',
      startText: 'Gasto aprox. ',
      endText: ' al mes en taxi/Uber',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'pays_public_transport',
    {
      label: '¿Sueles moverte en transporte público?',
      startText: '¿Sueles moverte en transporte público?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'public_transport_amount',
    {
      label: 'Gasto en transporte público',
      startText: 'Gasto aprox. ',
      endText: ' al mes en transporte público',
      type: questionTypes.NUMERIC,
    },
  ],

  [
    'education_exp',
    {
      label: 'Gasto en educación',
      type: questionTypes.NUMERIC,
      startText: 'Gasto ',
      endText: 'al mes en educación',
    },
  ],
  [
    'club_exp',
    {
      type: questionTypes.NUMERIC,
      startText: 'Gasto ',
      endText: 'al mes en gym, deportes y clases recreativas',
      label: 'Gasto en clases recreativas',
    },
  ],
  [
    'entertainment_exp',
    {
      type: questionTypes.NUMERIC,
      startText: 'Cada <u style="font-weight: bold">semana</u> gasto aprox. ',
      endText: ' en salidas',
      label: 'Gasto en salidas',
    },
  ],
  [
    'extra_exp',
    {
      type: questionTypes.YESNO,
      startText: '¿Tienes otros gastos obligatorios que no hayamos tomado en cuenta?',
      label: '¿Tienes otros gastos?',
    },
  ],
  [
    'exp_1_amount',
    {
      label: 'Gasto en primer gasto extra',
    },
  ],
  [
    'exp_2_amount',
    {
      label: 'Gasto en segundo gasto extra',
    },
  ],
  [
    'exp_3_amount',
    {
      label: 'Gasto en tercer gasto extra',
    },
  ],
  // Savings
  [
    'debit_period',
    {
      startText: 'Ahorro en mi cuenta de débito/nómina cada ',
      type: questionTypes.YESNO,
      label: 'Periodo de ahorro en cuenta de débito/nómina',
    },
  ],
  [
    'bw_debit_savings',
    {
      label: 'Ahorro quincenal en cuenta de débito/nómina',
      endText: ' en mi cuenta de débito/nómina',
      type: questionTypes.NUMERIC,
      startText: 'Cada quincena ahorro ',
    },
  ],
  [
    'mo_debit_savings',
    {
      label: 'Ahorro mensual en cuenta de débito/nómina',
      endText: ' en mi cuenta de débito/nómina',
      type: questionTypes.NUMERIC,
      startText: 'Cada mes ahorro ',
    },
  ],
  [
    'savings_debit',
    {
      label: 'Ahorrado en cuenta de débito/nómina',
      startText: 'Llevo ahorrado aprox. ',
      endText: ' en mi cuenta de débito/nómina',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'investment_period',
    {
      startText: 'Ahorro en mi cuenta de inversión cada ',
      type: questionTypes.YESNO,
      label: 'Periodo de ahorro en cuenta de inversión',
    },
  ],
  [
    'bw_investment_savings',
    {
      label: 'Ahorro quincenal en cuenta de inversión',
      endText: ' en mi cuenta de inversión',
      type: questionTypes.NUMERIC,
      startText: 'Cada quincena ahorro ',
    },
  ],
  [
    'mo_investment_savings',
    {
      label: 'Ahorro mensual en cuenta de inversión',
      endText: ' en mi cuenta de inversión',
      type: questionTypes.NUMERIC,
      startText: 'Cada mes ahorro ',
    },
  ],
  [
    'savings_investment',
    {
      label: 'Ahorrado en cuenta de inversión',
      startText: 'Llevo ahorrado aprox. ',
      endText: ' en mi cuenta de inversión',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'vault_period',
    {
      startText: 'Ahorro en mi caja de ahorro cada ',
      type: questionTypes.YESNO,
      label: 'Periodo de ahorro en caja de ahorro',
    },
  ],
  [
    'bw_vault_savings',
    {
      label: 'Ahorro quincenal en caja de ahorro',
      endText: ' en mi caja de ahorro',
      type: questionTypes.NUMERIC,
      startText: 'Cada quincena ahorro ',
    },
  ],
  [
    'mo_vault_savings',
    {
      label: 'Ahorro mensual en caja de ahorro',
      endText: ' en mi caja de ahorro',
      type: questionTypes.NUMERIC,
      startText: 'Cada mes ahorro ',
    },
  ],
  [
    'savings_vault',
    {
      label: 'Ahorrado en caja de ahorro',
      startText: 'Llevo ahorrado aprox. ',
      endText: ' en mi caja de ahorro',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'does_extra_afore',
    {
      startText: '¿Realizas "aportaciones complementarias" a tu Afore?',
      label: '¿Realizas "aportaciones complementarias" a tu Afore?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'afore_extra_period',
    {
      startText: 'Realizo "aportaciones complementarias" a mi Afore cada  ',
      type: questionTypes.YESNO,
      label: 'Periodo de "aportaciones complementarias" en AFORE',
    },
  ],
  [
    'afore_extra_bw_amount',
    {
      label: 'Aportaciones complementarias en Afore',
      endText: ' de "aportaciones complementarias" en Afore',
      type: questionTypes.NUMERIC,
      startText: 'Cada quincena ahorro ',
    },
  ],
  [
    'afore_extra_mo_amount',
    {
      label: 'Aportaciones complementarias en Afore',
      endText: ' de "aportaciones complementarias" en Afore',
      type: questionTypes.NUMERIC,
      startText: 'Cada mes ahorro ',
    },
  ],
  [
    'does_voluntary_afore',
    {
      startText: '¿Realizas "aportaciones voluntarias" a tu Afore?',
      label: '¿Realizas "aportaciones voluntarias" a tu Afore?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'afore_voluntary_period',
    {
      startText: 'Realizo "aportaciones voluntarias" a mi Afore cada  ',
      type: questionTypes.YESNO,
      label: 'Periodo de "aportaciones voluntarias" en AFORE',
    },
  ],
  [
    'afore_voluntary_bw_amount',
    {
      label: 'Aportaciones voluntarias en Afore',
      endText: ' de "aportaciones voluntarias" en Afore',
      type: questionTypes.NUMERIC,
      startText: 'Cada quincena ahorro ',
    },
  ],
  [
    'afore_voluntary_mo_amount',
    {
      label: 'Aportaciones voluntarias en Afore',
      endText: ' de "aportaciones voluntarias" en Afore',
      type: questionTypes.NUMERIC,
      startText: 'Cada mes ahorro ',
    },
  ],
  [
    'knows_afore_saved',
    {
      label: '¿Sabes cuánto dinero tienes ahorrado en tu Afore para el retiro?',
      startText: '¿Sabes cuánto dinero tienes ahorrado en tu Afore para el retiro?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'savings_afore',
    {
      label: 'Dinero ahorrado en Afore',
      startText: 'Tengo ahorrado aprox. ',
      endText: ' en mi Afore',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'years_working',
    {
      label: 'Años en un empleo formal',
      startText: 'Tengo aprox. ',
      endText: 'años trabajando en un empleo formal',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'years_worked_97',
    {
      label: 'Años en un empleo formal',
      startText: 'Tengo aprox. ',
      endText: 'años trabajando en un empleo formal',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'avg_salary',
    {
      label: 'Salario promedio',
      startText: 'Mi salario promedio después de impuestos durante ese periodo ha sido aprox.',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'avg_salary_97',
    {
      label: 'Salario promedio',
      startText: 'Mi salario promedio después de impuestos durante ese periodo ha sido aprox.',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'plan_period',
    {
      startText: 'Ahorro en mi Plan Personal para el Retiro cada ',
      type: questionTypes.YESNO,
      label: 'Periodo de ahorro en plan personal de retiro',
    },
  ],
  [
    'bw_plan_savings',
    {
      label: 'Ahorro quincenal en plan personal de retiro',
      endText: ' en mi Plan Personal para el Retiro',
      type: questionTypes.NUMERIC,
      startText: 'Cada quincena ahorro ',
    },
  ],
  [
    'mo_plan_savings',
    {
      label: 'Ahorro mensual en plan personal de retiro',
      endText: ' en mi Plan Personal para el Retiro',
      type: questionTypes.NUMERIC,
      startText: 'Cada mes ahorro ',
    },
  ],
  [
    'savings_ppr',
    {
      label: 'Ahorrado en plan personal de retiro',
      startText: 'Llevo ahorrado aprox. ',
      endText: ' en mi Plan Personal para el Retiro',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'extra_savings',
    {
      label: 'Ahorrado extra',
      startText: 'Llevo ahorrado aprox. ',
      endText: ' para mi retiro',
      type: questionTypes.NUMERIC,
    },
  ],
  // Goals / Experiences
  [
    'car_price',
    {
      label: 'Precio del auto que quiero',
      startText: 'El auto que quiero cuesta aprox. ',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'car_period',
    {
      startText: 'Quiero comprar mi auto en ',
      type: questionTypes.YESNO,
      label: 'Quiero comprar mi auto en',
    },
  ],
  [
    'prop_price',
    {
      label: 'Precio de la propiedad que quiero',
      startText: 'La propiedad que quiero cuesta aprox. ',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'prop_period',
    {
      startText: 'Quiero pagar el enganche de mi propiedad en ',
      type: questionTypes.YESNO,
      label: 'Quiero pagar el enganche de mi propiedad en',
    },
  ],
  [
    'vac_price',
    {
      label: 'Precio de las vacaciones que quiero',
      startText: 'Las vacaciones que quiero cuestan aprox. ',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'vac_period',
    {
      startText: 'Quiero tener mis vacaciones de ensueño en ',
      type: questionTypes.YESNO,
      label: 'Quiero tener mis vacaciones de ensueño en ',
    },
  ],
  [
    'wed_price',
    {
      label: 'Precio de la boda que quiero',
      startText: 'La boda que quiero cuesta aprox. ',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'wed_period',
    {
      startText: 'Quiero celebrar mi boda en ',
      type: questionTypes.YESNO,
      label: 'Quiero celebrar mi boda en ',
    },
  ],
  [
    'grad_price',
    {
      label: 'Precio del posgrado que quiero',
      startText: 'El posgrado que quiero cuesta aprox. ',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'grad_period',
    {
      startText: 'Quiero comenzar mi posgrado en ',
      type: questionTypes.YESNO,
      label: 'Quiero comenzar mi posgrado en  ',
    },
  ],
  [
    'remod_price',
    {
      label: 'Renovar mi propiedad cuesta aprox.',
      startText: 'Renovar mi propiedad cuesta aprox. ',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'remod_period',
    {
      startText: 'Quiero renovar mi propiedad en ',
      type: questionTypes.YESNO,
      label: 'Quiero renovar mi propiedad en  ',
    },
  ],
  [
    'char_price',
    {
      label: 'Donación a una causa',
      startText: 'Me gustaría donar aprox. ',
      endText: ' a una causa',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'char_period',
    {
      startText: 'Quiero donar a una causa en ',
      type: questionTypes.YESNO,
      label: 'Quiero donar a una causa en ',
    },
  ],
  [
    'other_price',
    {
      label: 'Cantidad para otra meta',
      startText: 'Me gustaría juntar aprox. ',
      endText: ' para otra meta',
      type: questionTypes.NUMERIC,
    },
  ],
  [
    'other_period',
    {
      startText: 'Quiero lograr otra meta en ',
      type: questionTypes.YESNO,
      label: 'Quiero lograr otra meta en ',
    },
  ],
  // insurance
  [
    'insurance_car',
    {
      type: questionTypes.YESNO,
      startText: '¿Tienes seguro de auto?',
      label: '¿Tienes seguro de auto?',
    },
  ],
  [
    'car_ins_period',
    {
      startText: '¿Cada cuánto pagas por tu seguro de auto?',
      label: '¿Cada cuánto pagas por tu seguro de auto?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'other_pays_car_ins',
    {
      type: questionTypes.YESNO,
      startText: '¿Alguien más paga por tu seguro de auto?',
      label: '¿Alguien más paga por tu seguro de auto?',
    },
  ],
  [
    'mo_car_ins_payment',
    {
      type: questionTypes.NUMERIC,
      startText: 'Pago aprox. ',
      endText: ' mensuales por mi seguro de auto',
      label: 'Pago de mi seguro de auto',
    },
  ],
  [
    'an_car_ins_payment',
    {
      type: questionTypes.NUMERIC,
      startText: 'Pago aprox. ',
      endText: ' anuales por mi seguro de auto',
      label: 'Pago de mi seguro de auto',
    },
  ],
  [
    'insurance_health',
    {
      type: questionTypes.YESNO,
      startText: '¿Tienes seguro de gastos médicos mayores?',
      label: '¿Tienes seguro de gastos médicos mayores?',
    },
  ],
  [
    'other_pays_med_ins',
    {
      type: questionTypes.YESNO,
      startText: '¿Alguien más paga por tu seguro de gastos médicos mayores?',
      label: '¿Alguien más paga por tu seguro de gastos médicos mayores?',
    },
  ],
  [
    'med_ins_period',
    {
      startText: '¿Cada cuánto pagas por tu seguro de gastos médicos mayores?',
      label: '¿Cada cuánto pagas por tu seguro de gastos médicos mayores?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'mo_med_ins_payment',
    {
      type: questionTypes.NUMERIC,
      startText: 'Pago aprox. ',
      endText: ' mensuales por mi seguro de gastos médicos mayores',
      label: 'Pago de mi seguro de gastos médicos mayores',
    },
  ],
  [
    'an_med_ins_payment',
    {
      type: questionTypes.NUMERIC,
      startText: 'Pago aprox. ',
      endText: ' anuales por mi seguro de gastos médicos mayores',
      label: 'Pago de mi seguro de gastos médicos mayores',
    },
  ],
  [
    'insurance_life',
    {
      type: questionTypes.YESNO,
      startText: '¿Tienes seguro de vida?',
      label: '¿Tienes seguro de vida?',
    },
  ],
  [
    'other_pays_life_ins',
    {
      type: questionTypes.YESNO,
      startText: '¿Alguien más paga por tu seguro de vida?',
      label: '¿Alguien más paga por tu seguro de vida?',
    },
  ],
  [
    'life_ins_period',
    {
      startText: '¿Cada cuánto pagas por tu seguro de vida?',
      label: '¿Cada cuánto pagas por tu seguro de vida?',
      type: questionTypes.YESNO,
    },
  ],
  [
    'mo_life_ins_payment',
    {
      type: questionTypes.NUMERIC,
      startText: 'Pago aprox. ',
      endText: ' mensuales por mi seguro de vida',
      label: 'Pago de mi seguro de vida',
    },
  ],
  [
    'an_life_ins_payment',
    {
      type: questionTypes.NUMERIC,
      startText: 'Pago aprox. ',
      endText: ' anuales por mi seguro de vida',
      label: 'Pago de mi seguro de vida',
    },
  ],
  // contact
  // ['receiving_channel', {
  //   startText: 'Me gustaría recibir mi plan por...',
  //   type: questionTypes.YESNO,
  //   label: 'Me gustaría recibir mi plan por...',
  // }],
  // ['phone_num', {
  //   startText: 'Mi teléfono es',
  //   label: 'Mi teléfono es',
  //   type: questionTypes.NUMERIC,
  // }],
  [
    'email',
    {
      startText: 'Quiero recibir una copia de mi plan a:',
      label: 'Quiero recibir una copia de mi plan a:',
      type: questionTypes.NUMERIC,
    },
  ],
]);

function generateChildrenInputs(n) {
  const order = [
    'primer',
    'segundo',
    'tercer',
    'cuarto',
    'quinto',
    'sexto',
    'séptimo',
    'octavo',
    'noveno',
    'décimo',
    'undécimo',
    'decimosegundo',
    'decimotercer',
    'decimocuarto',
    'decimoquinto',
    'decimosexto',
    'decimoséptimo',
    'decimoctavo',
    'decimonoveno',
    'vigésimo',
    'vigesimoprimer',
    'vigesimosegundo',
    'vigesimotercer',
    'vigesimocuarto',
    'vigesimoquinto',
    'vigesimosexto',
    'vigesimoséptimo',
    'vigesimoctavo',
    'vigesimonoveno',
    'trigésimo',
  ];

  const questions = [];

  for (let i = 0; i < n; i += 1) {
    const question = {
      inputName: `child_${i}`,
      value: null,
      type: questionTypes.NUMERIC,
      pattern: '[0-9]*',
      startText: `Mi ${order[i]} hijo tiene`,
      endText: 'años',
      placeholder: '',
      maxDigits: 2,
      inputMaxWidth: 3,
    };
    questions.push(question);
  }
  return questions;
}

function acceptDebt(x) {
  return [
    {
      inputName: `debt_${x}`,
      value: null,
      type: questionTypes.NUMERIC,
      pattern: '[0-9]*',
      prepend: '$',
      startText: 'Debo ',
      endText: 'en mi tarjeta',
      placeholder: '',
      maxDigits: 7,
      inputMaxWidth: 5,
      validation: Yup.string()
        .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
        .required('Este es un campo requerido'),
    },
    {
      inputName: `bank_${x}`,
      value: null,
      type: questionTypes.SELECTION,
      maxQuestions: 2,
      startText: 'Mi banco es ',
      endText: '',
      placeholder: 'Banco',
      validation: Yup.string().required('Este es un campo requerido'),
      answers: generateBankAnswers(bankInformationFrontEnd, x),
    },
  ];
}

export const hasPPR = {
  inputName: 'has_ppr',
  value: null,
  type: questionTypes.YESNO,
  startText: '¿Ahorras en un Plan Personal para el Retiro?',
  maxQuestions: 2,
  answers: [
    {
      label: 'Sí',
      hotkey: 'S',
      value: 1,
      extraQuestions: [
        {
          inputName: 'ppr_saving_period',
          ...inputMap.get('ppr_saving_period'),
          answers: [
            {
              label: 'quincena',
              value: 0,
              extraQuestions: [
                {
                  inputName: 'ppr_bw_savings',
                  prepend: '$',
                  ...inputMap.get('ppr_bw_savings'),
                  placeholder: '',
                  maxDigits: 8,
                  inputMaxWidth: 5,
                  validation: Yup.string()
                    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
                    .required('Este es un campo requerido'),
                },
              ],
            },
            {
              label: 'mes',
              value: 1,
              extraQuestions: [
                {
                  inputName: 'ppr_mo_savings',
                  prepend: '$',
                  ...inputMap.get('ppr_mo_savings'),
                  placeholder: '',
                  maxDigits: 8,
                  inputMaxWidth: 5,
                  validation: Yup.string()
                    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
                    .required('Este es un campo requerido'),
                },
              ],
            },
          ],
        },
        {
          inputName: 'savings_ppr',
          ...inputMap.get('savings_ppr'),
          prepend: '$',
          maxDigits: 8,
          placeholder: '',
          inputMaxWidth: 5,
          validation: Yup.string()
            .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
            .required('Este es un campo requerido'),
        },
      ],
    },
    {
      label: 'No',
      hotkey: 'N',
      value: 0,
    },
  ],
};

export const ahorro = [
  {
    inputName: 'monthly_contribution',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Quiero ahorrar ',
    endText: 'mensuales',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'years_to_save',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Por ',
    endText: 'años',
    placeholder: '',
    maxDigits: 3,
    inputMaxWidth: 2,
    validation: Yup.number()
      .moreThan(0, 'Debe ser mayor que cero')
      .lessThan(50, '¿En realidad quieres ahorrar por tanto tiempo? Ingresa un número entre 1 y 50')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'adjusted_contribution',
    base: true,
    value: null,
    type: questionTypes.YESNO,
    startText: '¿Tu ahorro mensual aumentará con la inflación?',
    maxQuestions: 2,
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
    reference: (
      <QuestionReference>
        <Text type="referenceTitle">Finauta recomienda:</Text>
        <Text type="reference">
          Que tu ahorro mensual <b>sí aumente</b> con la inflación ya que probablemente tus ingresos
          también lo hagan.
        </Text>
      </QuestionReference>
    ),
  },
  {
    inputName: 'annual_interest_rate',
    base: true,
    value: null,
    type: questionTypes.YESNO,
    startText: '¿Dónde te gustaría ahorrar?',
    maxQuestions: 2,
    answers: [
      {
        label: 'Bajo el colchón',
        value: 0,
      },
      {
        label: 'Banco',
        value: 1.5,
      },
      {
        label: 'Cetes',
        value: 7,
      },
      {
        label: 'Fondo de Ahorro',
        value: 9,
      },
      {
        label: 'Fondo de Inversión',
        value: 11,
      },
    ],
    reference: (
      <QuestionReference>
        <Text type="reference">
          Si no conoces la diferencia entre las opciones, no te preocupes. Muy pronto los podrás
          comparar.
        </Text>
      </QuestionReference>
    ),
  },
  {
    inputName: 'current_savings',
    base: true,
    final: '→ Calcular mi ahorro',
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Quiero que mi proyección considere ',
    endText: 'de mis ahorros',
    placeholder: '0',
    maxDigits: 10,
    inputMaxWidth: 6,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
    reference: (
      <QuestionReference>
        <Text type="reference">Esta información nos ayudará a calcular tu ahorro</Text>
      </QuestionReference>
    ),
  },
];

// Tiene afore?
export const extraContributionAfore = {
  inputName: 'extra_contribution_afore',
  value: null,
  type: questionTypes.YESNO,
  startText: '¿Realizas aportaciones complementarias a tu AFORE?',
  maxQuestions: 2,
  // reference: <QuestionReference>
  //   <Text type="reference">Ej. plan personal para el retiro y/o aportaciones complementarias a tu AFORE</Text>
  // </QuestionReference>,
  answers: [
    {
      label: 'Sí',
      hotkey: 'S',
      value: 1,
      extraQuestions: [
        {
          inputName: 'extra_afore_saving_period',
          ...inputMap.get('extra_afore_saving_period'),
          answers: [
            {
              label: 'quincena',
              value: 0,
              extraQuestions: [
                {
                  inputName: 'extra_afore_bw_savings',
                  prepend: '$',
                  ...inputMap.get('extra_afore_bw_savings'),
                  placeholder: '',
                  maxDigits: 8,
                  inputMaxWidth: 5,
                  validation: Yup.string()
                    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
                    .required('Este es un campo requerido'),
                },
              ],
            },
            {
              label: 'mes',
              value: 1,
              extraQuestions: [
                {
                  inputName: 'extra_afore_mo_savings',
                  prepend: '$',
                  ...inputMap.get('extra_afore_mo_savings'),
                  placeholder: '',
                  maxDigits: 8,
                  inputMaxWidth: 5,
                  validation: Yup.string()
                    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
                    .required('Este es un campo requerido'),
                },
              ],
            },
          ],
        },
        hasPPR,
      ],
    },
    {
      label: 'No',
      hotkey: 'N',
      value: 0,
      extraQuestions: [hasPPR],
    },
  ],
};

// Retirement ISSTE / IMSS
export const currentAFORE = {
  inputName: 'knows_afore_saved',
  ...inputMap.get('knows_afore_saved'),
  reference: (
    <QuestionReference>
      <Text type="reference">Si no lo sabes, no te preocupes. Te ayudaremos a calcularlo</Text>
    </QuestionReference>
  ),
  answers: [
    {
      label: 'Sí',
      value: 1,
      hotkey: 'S',
      extraQuestions: [
        {
          inputName: 'savings_afore',
          ...inputMap.get('savings_afore'),
          prepend: '$',
          maxDigits: 8,
          placeholder: '',

          inputMaxWidth: 5,
          validation: Yup.string()
            .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
            .required('Este es un campo requerido'),
        },
        extraContributionAfore,
      ],
    },
    {
      label: 'No',
      value: 0,
      hotkey: 'N',
      extraQuestions: [
        {
          inputName: 'years_worked_97',
          ...inputMap.get('years_worked_97'),
          placeholder: '',
          noThousandSeparator: true,
          inputMaxWidth: 2,
          validation: Yup.number()
            .required('Este es un campo requerido')
            .lessThan(100, 'Debe ser menor que 100')
            .moreThan(0, 'Ingresa un número mayor a cero'),
        },
        {
          inputName: 'avg_salary_97',
          ...inputMap.get('avg_salary_97'),
          prepend: '$',
          maxDigits: 8,
          inputMaxWidth: 5,
          placeholder: '',

          validation: Yup.string()
            .matches(/^[1-9]+(?:,[0-9]+)*(?:\.[0-9]+)?/, 'Debe ser mayor que cero')
            .required('Este es un campo requerido'),
        },
        extraContributionAfore,
      ],
    },
  ],
};

// Tercera sección
export const expenses = [
  {
    inputName: 'total_income',
    base: true,
    value: null,
    pattern: '[0-9]*',
    ...inputMap.get('total_income'),
    prepend: '$',
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'rents',
    value: null,
    base: true,
    ...inputMap.get('rents'),
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
        extraQuestions: [
          {
            inputName: 'rent_exp',
            value: null,
            pattern: '[0-9]*',
            prepend: '$',
            ...inputMap.get('rent_exp'),
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
  },
  {
    inputName: 'phone_exp',
    base: true,
    value: null,
    pattern: '[0-9]*',
    prepend: '$',
    ...inputMap.get('phone_exp'),
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'services_exp',
    base: true,
    value: null,
    pattern: '[0-9]*',
    prepend: '$',
    ...inputMap.get('services_exp'),
    placeholder: '',
    maxDigits: 6,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <Text type="reference">
          Aquí incluye agua, luz, teléfono fijo, internet y membresías (Por ejemplo, Netflix,
          Spotify)
        </Text>
      </QuestionReference>
    ),

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'groceries_exp',
    base: true,
    value: null,
    pattern: '[0-9]*',
    ...inputMap.get('groceries_exp'),
    prepend: '$',
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <Text type="reference">
          Incluye aquí compras que realizas para consumir o dar mantenimiento al hogar
        </Text>
      </QuestionReference>
    ),

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'pays_gas',
    base: true,
    ...inputMap.get('pays_gas'),
    answers: [
      {
        label: 'Sí',
        value: 1,
        hotkey: 'S',
        extraQuestions: [
          {
            inputName: 'gas_amount',
            ...inputMap.get('gas_amount'),
            pattern: '[0-9]*',
            prepend: '$',
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'No',
        value: 0,
        hotkey: 'N',
      },
    ],
  },
  {
    inputName: 'pays_uber',
    base: true,
    ...inputMap.get('pays_uber'),
    answers: [
      {
        label: 'Sí',
        value: 1,
        hotkey: 'S',
        extraQuestions: [
          {
            inputName: 'uber_amount',
            ...inputMap.get('uber_amount'),
            pattern: '[0-9]*',
            prepend: '$',
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'No',
        value: 0,
        hotkey: 'N',
      },
    ],
  },
  {
    inputName: 'pays_public_transport',
    base: true,
    ...inputMap.get('pays_public_transport'),
    answers: [
      {
        label: 'Sí',
        value: 1,
        hotkey: 'S',
        extraQuestions: [
          {
            inputName: 'public_transport_amount',
            ...inputMap.get('public_transport_amount'),
            pattern: '[0-9]*',
            prepend: '$',
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'No',
        value: 0,
        hotkey: 'N',
      },
    ],
  },

  {
    inputName: 'education_exp',
    base: true,
    value: null,
    pattern: '[0-9]*',
    ...inputMap.get('education_exp'),
    prepend: '$',
    placeholder: '',
    maxDigits: 6,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <Text type="reference">Incluye aquí colegiaturas, cursos académicos y diplomados</Text>
      </QuestionReference>
    ),

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },

  {
    inputName: 'club_exp',
    base: true,
    value: null,
    pattern: '[0-9]*',
    prepend: '$',
    ...inputMap.get('club_exp'),
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'entertainment_exp',
    base: true,
    value: null,
    pattern: '[0-9]*',
    prepend: '$',
    ...inputMap.get('entertainment_exp'),
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <References style={{ marginBottom: '5px' }}>
          <Text type="reference">Incluye aquí salidas con amigos/pareja, bares, cine, etc.</Text>
        </References>
      </QuestionReference>
    ),
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  // TODO: Verificar que extra expenses funcione...
  {
    inputName: 'extra_exp',
    value: null,
    base: true,
    ...inputMap.get('extra_exp'),
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
        extraQuestions: [
          ...generateExpenseQuestion(1),
          {
            inputName: 'extra_exp_1',
            base: true,
            ...inputMap.get('extra_exp_1'),
            reference: (
              <QuestionReference>
                <Text type="reference">
                  Por ejemplo, apoyo a una causa, un familiar o una mascota
                </Text>
              </QuestionReference>
            ),
            answers: [
              {
                label: 'Sí',
                hotkey: 'S',
                value: 1,
                extraQuestions: [
                  ...generateExpenseQuestion(2),
                  {
                    inputName: 'extra_exp_2',
                    base: true,
                    ...inputMap.get('extra_exp_2'),
                    reference: (
                      <QuestionReference>
                        <Text type="reference">
                          Por ejemplo, apoyo a una causa, un familiar o una mascota
                        </Text>
                      </QuestionReference>
                    ),
                    answers: [
                      {
                        label: 'Sí',
                        hotkey: 'S',
                        value: 1,
                        extraQuestions: [...generateExpenseQuestion(3)],
                      },
                      {
                        label: 'No',
                        hotkey: 'N',
                        value: 0,
                      },
                    ],
                  },
                ],
              },
              {
                label: 'No',
                hotkey: 'N',
                value: 0,
              },
            ],
          },
        ],
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
    reference: (
      <QuestionReference>
        <Text type="reference">Por ejemplo, apoyo a una causa, un familiar o una mascota</Text>
      </QuestionReference>
    ),
  },
];
// Empieza Picker de ahorro
export const debitSavings = [
  {
    inputName: 'debit_period',
    base: true,
    ...inputMap.get('debit_period'),
    answers: [
      {
        label: 'quincena',
        value: 0,
        extraQuestions: [
          {
            inputName: 'bw_debit_savings',
            prepend: '$',
            ...inputMap.get('bw_debit_savings'),
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'mes',
        value: 1,
        extraQuestions: [
          {
            inputName: 'mo_debit_savings',
            prepend: '$',
            ...inputMap.get('mo_debit_savings'),
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
    ],
  },
  {
    inputName: 'savings_debit',
    base: true,
    prepend: '$',
    ...inputMap.get('savings_debit'),
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
];

export const investmentSavings = [
  {
    inputName: 'investment_period',
    base: true,
    ...inputMap.get('investment_period'),
    answers: [
      {
        label: 'quincena',
        value: 0,
        extraQuestions: [
          {
            inputName: 'bw_investment_savings',
            prepend: '$',
            ...inputMap.get('bw_investment_savings'),
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'mes',
        value: 1,
        extraQuestions: [
          {
            inputName: 'mo_investment_savings',
            prepend: '$',
            ...inputMap.get('mo_investment_savings'),
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
    ],
  },
  {
    inputName: 'savings_investment',
    base: true,
    prepend: '$',
    ...inputMap.get('savings_investment'),
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
];

export const vaultSavings = [
  {
    inputName: 'vault_period',
    base: true,
    ...inputMap.get('vault_period'),
    answers: [
      {
        label: 'quincena',
        value: 0,
        extraQuestions: [
          {
            inputName: 'bw_vault_savings',
            prepend: '$',
            ...inputMap.get('bw_vault_savings'),
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'mes',
        value: 1,
        extraQuestions: [
          {
            inputName: 'mo_vault_savings',
            prepend: '$',
            ...inputMap.get('mo_vault_savings'),
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
    ],
  },
  {
    inputName: 'savings_vault',
    base: true,
    prepend: '$',
    ...inputMap.get('savings_vault'),
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
];

export const aforeSavings = [
  // {
  //   inputName: 'does_extra_afore',
  //   ...inputMap.get('does_extra_afore'),
  //   answers: [
  //     {
  //       label: 'Sí',
  //       value: 1,
  //       hotkey: 'S',
  //       extraQuestions: [
  //         {
  //           inputName: 'afore_extra_period',
  //           ...inputMap.get('afore_extra_period'),
  //           answers: [
  //             {
  //               label: 'Quincena',
  //               value: 'bw',
  //               hotkey: 'Q',
  //               extraQuestions: [
  //                 {
  //                   inputName: 'afore_extra_bw_amount',
  //                   ...inputMap.get('afore_extra_bw_amount'),
  //                   prepend: '$',
  //                   maxDigits: 8,
  //                   inputMaxWidth: 5,
  //                   placeholder: '',
  //                   validation: Yup.string()
  //                     .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
  //                     .required('Este es un campo requerido'),
  //                 }
  //               ],
  //             },
  //             {
  //               label: 'Mes',
  //               value: 'mo',
  //               hotkey: 'M',
  //               extraQuestions: [
  //                 {
  //                   inputName: 'afore_extra_mo_amount',
  //                   ...inputMap.get('afore_extra_mo_amount'),
  //                   prepend: '$',
  //                   placeholder: '',

  //                   maxDigits: 8,
  //                   inputMaxWidth: 5,
  //                   validation: Yup.string()
  //                     .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
  //                     .required('Este es un campo requerido'),
  //                 },
  //               ],
  //             }
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       label: 'No',
  //       value: 0,
  //       hotkey: 'N',
  //     },
  //   ],
  //   reference: <QuestionReference>
  //     <Text type="reference">
  //     Sólo podrás acceder a tus "aportaciones complementarias" en el retiro
  //     </Text>
  //   </QuestionReference>
  // },
  {
    inputName: 'does_voluntary_afore',
    base: true,
    ...inputMap.get('does_voluntary_afore'),
    answers: [
      {
        label: 'Sí',
        value: 1,
        hotkey: 'S',
        extraQuestions: [
          {
            inputName: 'afore_voluntary_period',
            ...inputMap.get('afore_voluntary_period'),
            answers: [
              {
                label: 'Quincena',
                value: 'bw',
                hotkey: 'Q',
                extraQuestions: [
                  {
                    inputName: 'afore_voluntary_bw_amount',
                    ...inputMap.get('afore_voluntary_bw_amount'),
                    prepend: '$',
                    maxDigits: 8,
                    inputMaxWidth: 5,
                    placeholder: '',

                    validation: Yup.string()
                      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
                      .required('Este es un campo requerido'),
                  },
                ],
              },
              {
                label: 'Mes',
                value: 'mo',
                hotkey: 'M',
                extraQuestions: [
                  {
                    inputName: 'afore_voluntary_mo_amount',
                    ...inputMap.get('afore_voluntary_mo_amount'),
                    prepend: '$',
                    maxDigits: 8,
                    inputMaxWidth: 5,
                    placeholder: '',

                    validation: Yup.string()
                      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
                      .required('Este es un campo requerido'),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
    reference: (
      <QuestionReference>
        <Text type="reference">
          Podrás acceder a tus "aportaciones voluntarias" antes del retiro
        </Text>
      </QuestionReference>
    ),
  },
  {
    inputName: 'knows_afore_saved',
    base: true,
    ...inputMap.get('knows_afore_saved'),
    reference: (
      <QuestionReference>
        <Text type="reference">Si no lo sabes, no te preocupes. Te ayudaremos a calcularlo</Text>
      </QuestionReference>
    ),
    answers: [
      {
        label: 'Sí',
        value: 1,
        hotkey: 'S',
        extraQuestions: [
          {
            inputName: 'savings_afore',
            ...inputMap.get('savings_afore'),
            prepend: '$',
            maxDigits: 8,
            placeholder: '',

            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'No',
        value: 0,
        hotkey: 'N',
        extraQuestions: [
          {
            inputName: 'years_working',
            ...inputMap.get('years_working'),
            placeholder: '',
            noThousandSeparator: true,
            inputMaxWidth: 2,
            validation: Yup.number()
              .required('Este es un campo requerido')
              .lessThan(100, 'Debe ser menor que 100')
              .moreThan(0, 'Ingresa un número mayor a cero'),
          },
          {
            inputName: 'avg_salary',
            ...inputMap.get('avg_salary'),
            prepend: '$',
            maxDigits: 8,
            inputMaxWidth: 5,
            placeholder: '',

            validation: Yup.string()
              .matches(/^[1-9]+(?:,[0-9]+)*(?:\.[0-9]+)?/, 'Debe ser mayor que cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
    ],
  },
];

export const planSavings = [
  {
    inputName: 'plan_period',
    base: true,
    ...inputMap.get('plan_period'),
    answers: [
      {
        label: 'quincena',
        value: 0,
        extraQuestions: [
          {
            inputName: 'bw_plan_savings',
            prepend: '$',
            ...inputMap.get('bw_plan_savings'),
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'mes',
        value: 1,
        extraQuestions: [
          {
            inputName: 'mo_plan_savings',
            prepend: '$',
            ...inputMap.get('mo_plan_savings'),
            placeholder: '',
            maxDigits: 8,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
    ],
  },
  {
    inputName: 'savings_ppr',
    base: true,
    prepend: '$',
    ...inputMap.get('savings_ppr'),
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
];
// Termina Picker de ahorro

// Empieza Picker de experiencias
export const carExp = [
  {
    inputName: 'car_price',
    base: true,
    prepend: '$',
    placeholder: '',
    ...inputMap.get('car_price'),
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'car_period',
    base: true,
    ...inputMap.get('car_period'),
    answers: [
      {
        label: '2 años o menos',
        value: '<=2',
      },
      {
        label: '3 a 5 años',
        value: '3-5',
      },
      {
        label: 'más de 5 años',
        value: '>5',
      },
    ],
  },
];

export const propExp = [
  {
    inputName: 'prop_price',
    base: true,
    prepend: '$',
    placeholder: '',
    ...inputMap.get('prop_price'),
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'prop_period',
    base: true,
    ...inputMap.get('prop_period'),
    answers: [
      {
        label: '2 años o menos',
        value: '<=2',
      },
      {
        label: '3 a 5 años',
        value: '3-5',
      },
      {
        label: 'más de 5 años',
        value: '>5',
      },
    ],
  },
];

export const vacExp = [
  {
    inputName: 'vac_price',
    base: true,
    prepend: '$',
    placeholder: '',
    ...inputMap.get('vac_price'),
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'vac_period',
    base: true,
    ...inputMap.get('vac_period'),
    answers: [
      {
        label: '2 años o menos',
        value: '<=2',
      },
      {
        label: '3 a 5 años',
        value: '3-5',
      },
      {
        label: 'más de 5 años',
        value: '>5',
      },
    ],
  },
];

export const wedExp = [
  {
    inputName: 'wed_price',
    base: true,
    prepend: '$',
    placeholder: '',
    ...inputMap.get('wed_price'),
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'wed_period',
    base: true,
    ...inputMap.get('wed_period'),
    answers: [
      {
        label: '2 años o menos',
        value: '<=2',
      },
      {
        label: '3 a 5 años',
        value: '3-5',
      },
      {
        label: 'más de 5 años',
        value: '>5',
      },
    ],
  },
];

export const gradExp = [
  {
    inputName: 'grad_price',
    base: true,
    prepend: '$',
    placeholder: '',
    ...inputMap.get('grad_price'),
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'grad_period',
    base: true,
    ...inputMap.get('grad_period'),
    answers: [
      {
        label: '2 años o menos',
        value: '<=2',
      },
      {
        label: '3 a 5 años',
        value: '3-5',
      },
      {
        label: 'más de 5 años',
        value: '>5',
      },
    ],
  },
];

export const remodExp = [
  {
    inputName: 'remod_price',
    base: true,
    prepend: '$',
    placeholder: '',
    ...inputMap.get('remod_price'),
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'remod_period',
    base: true,
    ...inputMap.get('remod_period'),
    answers: [
      {
        label: '2 años o menos',
        value: '<=2',
      },
      {
        label: '3 a 5 años',
        value: '3-5',
      },
      {
        label: 'más de 5 años',
        value: '>5',
      },
    ],
  },
];

export const charExp = [
  {
    inputName: 'char_price',
    base: true,
    prepend: '$',
    placeholder: '',
    ...inputMap.get('char_price'),
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'char_period',
    base: true,
    ...inputMap.get('char_period'),
    answers: [
      {
        label: '2 años o menos',
        value: '<=2',
      },
      {
        label: '3 a 5 años',
        value: '3-5',
      },
      {
        label: 'más de 5 años',
        value: '>5',
      },
    ],
  },
];

export const otherExp = [
  {
    inputName: 'other_price',
    base: true,
    prepend: '$',
    placeholder: '',
    ...inputMap.get('other_price'),
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'other_period',
    base: true,
    ...inputMap.get('other_period'),
    answers: [
      {
        label: '2 años o menos',
        value: '<=2',
      },
      {
        label: '3 a 5 años',
        value: '3-5',
      },
      {
        label: 'más de 5 años',
        value: '>5',
      },
    ],
  },
];
// Termina Picker de experiencias

// Sexta sección
export const insurance = [
  {
    inputName: 'insurance_car',
    base: true,
    ...inputMap.get('insurance_car'),
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
        extraQuestions: [
          {
            inputName: 'other_pays_car_ins',
            reference: (
              <QuestionReference>
                <Text type="reference">Por ejemplo: tu empleador, tus papás, etc.</Text>
              </QuestionReference>
            ),
            ...inputMap.get('other_pays_car_ins'),
            answers: [
              {
                label: 'Sí',
                hotkey: 'S',
                value: 1,
              },
              {
                label: 'No',
                hotkey: 'N',
                value: 0,
                extraQuestions: [
                  {
                    inputName: 'car_ins_period',
                    ...inputMap.get('car_ins_period'),
                    answers: [
                      {
                        label: 'mensual',
                        value: 0,
                        extraQuestions: [
                          {
                            inputName: 'mo_car_ins_payment',
                            placeholder: '',
                            prepend: '$',
                            ...inputMap.get('mo_car_ins_payment'),
                            maxDigits: 8,
                            inputMaxWidth: 5,
                            validation: Yup.string()
                              .matches(
                                /^\d{1,3}(,\d{3})*(\.\d+)?$/,
                                'Debe ser mayor o igual a cero',
                              )
                              .required('Este es un campo requerido'),
                          },
                        ],
                      },
                      {
                        label: 'anual',
                        value: 1,
                        extraQuestions: [
                          {
                            inputName: 'an_car_ins_payment',
                            placeholder: '',
                            prepend: '$',
                            ...inputMap.get('an_car_ins_payment'),
                            maxDigits: 8,
                            inputMaxWidth: 5,
                            validation: Yup.string()
                              .matches(
                                /^\d{1,3}(,\d{3})*(\.\d+)?$/,
                                'Debe ser mayor o igual a cero',
                              )
                              .required('Este es un campo requerido'),
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            label: 'No',
            hotkey: 'N',
            value: 0,
          },
        ],
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
  },
  {
    inputName: 'insurance_health',
    base: true,
    ...inputMap.get('insurance_health'),
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
        extraQuestions: [
          {
            inputName: 'other_pays_med_ins',
            reference: (
              <QuestionReference>
                <Text type="reference">Por ejemplo: tu empleador, tus papás, etc.</Text>
              </QuestionReference>
            ),
            ...inputMap.get('other_pays_med_ins'),
            answers: [
              {
                label: 'Sí',
                hotkey: 'S',
                value: 1,
              },
              {
                label: 'No',
                hotkey: 'N',
                value: 0,
                extraQuestions: [
                  {
                    ...inputMap.get('med_ins_period'),
                    inputName: 'med_ins_period',
                    answers: [
                      {
                        label: 'mensual',
                        value: 0,
                        extraQuestions: [
                          {
                            inputName: 'mo_med_ins_payment',
                            placeholder: '',
                            prepend: '$',
                            ...inputMap.get('mo_med_ins_payment'),
                            maxDigits: 8,
                            inputMaxWidth: 5,
                            validation: Yup.string()
                              .matches(
                                /^\d{1,3}(,\d{3})*(\.\d+)?$/,
                                'Debe ser mayor o igual a cero',
                              )
                              .required('Este es un campo requerido'),
                          },
                        ],
                      },
                      {
                        label: 'anual',
                        value: 1,
                        extraQuestions: [
                          {
                            inputName: 'an_med_ins_payment',
                            placeholder: '',
                            prepend: '$',
                            ...inputMap.get('an_med_ins_payment'),
                            maxDigits: 8,
                            inputMaxWidth: 5,
                            validation: Yup.string()
                              .matches(
                                /^\d{1,3}(,\d{3})*(\.\d+)?$/,
                                'Debe ser mayor o igual a cero',
                              )
                              .required('Este es un campo requerido'),
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
  },
  {
    inputName: 'insurance_life',
    base: true,
    ...inputMap.get('insurance_life'),

    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
        extraQuestions: [
          {
            inputName: 'other_pays_life_ins',
            ...inputMap.get('other_pays_life_ins'),
            reference: (
              <QuestionReference>
                <Text type="reference">Por ejemplo: tu empleador, tus papás, etc.</Text>
              </QuestionReference>
            ),
            answers: [
              {
                label: 'Sí',
                hotkey: 'S',
                value: 1,
              },
              {
                label: 'No',
                hotkey: 'N',
                value: 0,
                extraQuestions: [
                  {
                    ...inputMap.get('life_ins_period'),
                    inputName: 'life_ins_period',
                    answers: [
                      {
                        label: 'mensual',
                        value: 0,
                        extraQuestions: [
                          {
                            inputName: 'mo_life_ins_payment',
                            placeholder: '',
                            prepend: '$',
                            ...inputMap.get('mo_life_ins_payment'),
                            maxDigits: 8,
                            inputMaxWidth: 5,
                            validation: Yup.string()
                              .matches(
                                /^\d{1,3}(,\d{3})*(\.\d+)?$/,
                                'Debe ser mayor o igual a cero',
                              )
                              .required('Este es un campo requerido'),
                          },
                        ],
                      },
                      {
                        label: 'anual',
                        value: 1,
                        extraQuestions: [
                          {
                            inputName: 'an_life_ins_payment',
                            placeholder: '',
                            prepend: '$',
                            ...inputMap.get('an_life_ins_payment'),
                            maxDigits: 8,
                            inputMaxWidth: 5,
                            validation: Yup.string()
                              .matches(
                                /^\d{1,3}(,\d{3})*(\.\d+)?$/,
                                'Debe ser mayor o igual a cero',
                              )
                              .required('Este es un campo requerido'),
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
  },
];

// Séptima y última sección
export const contact = [
  {
    inputName: 'email',
    base: true,
    prepend: '',
    endText: '',
    final: '→ Obtener mi GPS financiero',
    ...inputMap.get('email'),
    isTextual: true,
    placeholder: 'tucorreo@ejemplo.com',
    maxDigits: 80,
    inputSpanWidth: 20,
    inputWidth: '250px',
    inputMaxWidth: 100,
    validation: Yup.string()
      .email('Debe ser un correo electrónico válido')
      .required('Este es un campo requerido'),
  },
];

export const budget = [
  {
    inputName: 'total_income',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Mi ingreso mensual después de impuestos es ',
    prepend: '$',
    endText: '',
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'rent_exp',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Gasto ',
    prepend: '$',
    endText: 'al mes en renta',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <Text type="reference">Ingresa cero si no rentas</Text>
      </QuestionReference>
    ),
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'mortgage_exp',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Gasto ',
    prepend: '$',
    endText: 'al mes en hipoteca',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <Text type="reference">
          Ingresa cero si no pagas hipoteca. Esto puede ser para una propiedad que estás pagando
          vivas o no en ella
        </Text>
      </QuestionReference>
    ),

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'services_exp',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Gasto ',
    prepend: '$',
    endText: 'al mes en servicios',
    placeholder: '',
    maxDigits: 6,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <Text type="reference">
          Aquí incluye agua, luz, teléfono fijo, internet y membresías (Por ejemplo, Netflix,
          Spotify)
        </Text>
      </QuestionReference>
    ),

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'phone_exp',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Gasto ',
    prepend: '$',
    endText: 'al mes en plan o recargas de teléfono celular',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'groceries_exp',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Gasto ',
    prepend: '$',
    endText: 'al mes en despensa',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <Text type="reference">
          Incluye aquí compras que realizas para consumir o dar mantenimiento al hogar
        </Text>
      </QuestionReference>
    ),

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'transportation_exp',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Gasto ',
    prepend: '$',
    endText: 'al mes en transporte',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <Text type="reference">
          Incluye aquí gasolina, transporte público, Uber y vías de cuota
        </Text>
      </QuestionReference>
    ),

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'education_exp',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Gasto ',
    prepend: '$',
    endText: 'al mes en educación',
    placeholder: '',
    maxDigits: 6,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <Text type="reference">Incluye aquí colegiaturas, cursos académicos y diplomados</Text>
      </QuestionReference>
    ),

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'club_exp',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Gasto ',
    prepend: '$',
    endText: 'al mes en clubes y asociaciones',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <Text type="reference">
          Incluye aquí tu gasto en gimnasio, clases recreativas y deportes
        </Text>
      </QuestionReference>
    ),

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'entertainment_exp',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Gasto ',
    prepend: '$',
    endText: 'al mes en entretenimiento',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,
    reference: (
      <QuestionReference>
        <References style={{ marginBottom: '5px' }}>
          <li>
            <Text type="reference">Incluye aquí salidas con amigos/pareja, bares, cine, etc.</Text>
          </li>
          <li>
            <Text type="reference">
              Sabemos que es difícil llevar un control de tus salidas, por esto te pedimos un monto
              al mes con el que te sientas cómodo sin excederte.
            </Text>
          </li>
        </References>
      </QuestionReference>
    ),

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'extra_exp',
    value: null,
    base: true,
    type: questionTypes.YESNO,
    startText: '¿Tienes otros gastos obligatorios que no hayamos tomado en cuenta?',
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
        extraQuestions: [
          {
            inputName: 'extra_exp_amount',
            startText: 'Gasto ',
            prepend: '$',
            endText: 'al mes en otros gastos obligatorios',
            type: questionTypes.NUMERIC,
            pattern: '[0-9.]*',
            placeholder: '',
            maxDigits: 7,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
    reference: (
      <QuestionReference>
        <Text type="reference">Por ejemplo, apoyo a una causa, un familiar o una mascota</Text>
      </QuestionReference>
    ),
  },
];

export const dummyBudget = [
  {
    inputName: 'total_income',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Mi ingreso mensual después de impuestos es ',
    prepend: '$',
    endText: '',
    placeholder: '',
    maxDigits: 8,
    inputMaxWidth: 5,

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'rents',
    value: null,
    base: true,
    type: questionTypes.YESNO,
    startText: '¿Rentas depa/casa?',
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
        extraQuestions: [
          {
            inputName: 'rent_exp',
            value: null,
            type: questionTypes.NUMERIC,
            pattern: '[0-9]*',
            startText: 'Gasto ',
            prepend: '$',
            endText: 'al mes en renta',
            placeholder: '',
            maxDigits: 7,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
  },
  {
    inputName: 'extra_exp',
    value: null,
    base: true,
    type: questionTypes.YESNO,
    startText: '¿Tienes otros gastos obligatorios que no hayamos tomado en cuenta?',
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
        extraQuestions: [
          {
            inputName: 'extra_exp_amount',
            startText: 'Gasto ',
            prepend: '$',
            endText: 'al mes en otros gastos obligatorios',
            type: questionTypes.NUMERIC,
            pattern: '[0-9.]*',
            placeholder: '',
            maxDigits: 6,
            inputMaxWidth: 5,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
    reference: (
      <QuestionReference>
        <Text type="reference">Por ejemplo, apoyo a una causa, un familiar o una mascota</Text>
      </QuestionReference>
    ),
  },
];

export const moneda = [
  {
    inputName: 'initial_amount',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Quiero empezar con ',
    prepend: '$',
    endText: '',
    placeholder: '',
    maxDigits: 7,
    inputMaxWidth: 5,

    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'months_to_save',
    base: true,
    // TODO: Como es la pregunta final y es de texto no será necesario lo de que salge otro botón...
    // Agregando "final" debe funcionar.
    final: '→ Calcular moneda',
    placeholder: '3 meses',
    type: questionTypes.YESNO,
    startText: 'Quiero ahorrar por',
    answers: [
      {
        label: '3 meses',
        value: '3',
      },
      {
        label: '6 meses',
        value: '6',
      },
      {
        label: '1 año',
        value: '12',
      },
      {
        label: '3 años',
        value: '36',
      },
      {
        label: 'otro',
        value: '1',
        extraQuestions: [
          {
            inputName: 'months_to_save',
            value: '12',
            type: questionTypes.NUMERIC,
            pattern: '[0-9.]*',
            startText: '',
            endText: ' meses',
            placeholder: '12',
            maxDigits: 2,
            inputMaxWidth: 2,
            validation: Yup.number()
              .required('Este es un campo requerido')
              .lessThan(61, '¿En realidad quieres ahorrar por tanto tiempo?'),
          },
        ],
      },
    ],
  },
];

export const consolidacionCredito = [
  ...acceptDebt(1),
  {
    inputName: 'add_card_1',
    base: true,
    value: null,
    type: questionTypes.YESNO,
    startText: '¿Quieres agregar otra tarjeta?',
    maxQuestions: 2,
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
        extraQuestions: acceptDebt(2),
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
  },
  {
    inputName: 'payment_periods',
    final: '→ Calcular mi ahorro',
    base: true,
    value: null,
    type: questionTypes.YESNO,
    startText: '¿En cuántos meses te gustaría pagar tu deuda?',
    justValue: false,
    answers: [
      {
        label: '6',
        value: 6,
      },
      {
        label: '12',
        value: 12,
      },
      {
        label: '18',
        value: 18,
      },
      {
        label: '24',
        value: 24,
      },
    ],
  },
];

export const goalDueDate = [
  {
    inputName: 'expectedAge',
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Quiero lograr esta meta cuando tenga ',
    endText: 'años',
    placeholder: '',
    maxDigits: 3,
    inputMaxWidth: 2,
  },
];

export const retirementGoalDueDate = [
  {
    inputName: 'expectedAge',
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Quiero retirarme a los ',
    endText: 'años',
    placeholder: '',
    maxDigits: 3,
    inputMaxWidth: 2,
  },
];

export const weddingGoalDueDate = [
  {
    inputName: 'expectedAge',
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Quiero casarme a mis ',
    endText: 'años',
    placeholder: '',
    maxDigits: 3,
    inputMaxWidth: 2,
  },
];

export const carGoalMoneyRequired = {
  inputName: 'moneyRequired',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'El auto que quiero cuesta más o menos ',
  endText: 'pesos',
  placeholder: '200,000',
  maxDigits: 10, // 10 because we want 99,999,999 to be the largest number
  inputMaxWidth: 6,
  validation: Yup.string()
    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
    .required('Este es un campo requerido'),
  reference: (
    <QuestionReference>
      <Text type="referenceTitle">Como referencia:</Text>
      <References style={{ marginBottom: '5px' }}>
        <li>
          <Text type="reference">
            Un Nissan Versa 2018 cuesta $183,000 con un enganche de $37,000
          </Text>
        </li>
        <li>
          <Text type="reference">
            Un Volkswagen Vento 2018 cuesta $240,000 con un enganche de $48,000
          </Text>
        </li>
        <li>
          <Text type="reference">Un Audi A1 2018 cuesta $360,000 con un enganche de $72,000</Text>
        </li>
      </References>
      <Text type="reference">Visita el Libro Azul para mayor detalle</Text>
    </QuestionReference>
  ),
};

export const propertyGoalMoneyRequired = {
  inputName: 'moneyRequired',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'El enganche o precio final de la propiedad que quiero cuesta ',
  endText: 'pesos',
  placeholder: '1,500,000',
  maxDigits: 10, // 10 because we want 99,999,999 to be the largest number
  inputMaxWidth: 6,
  validation: Yup.string()
    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
    .required('Este es un campo requerido'),
  reference: (
    <QuestionReference>
      <Text type="referenceTitle">Como referencia:</Text>
      <References>
        <li>
          <Text type="reference">
            Departamento CDMX: $2 millones de pesos; enganche de $400,000
          </Text>
        </li>
        <li>
          <Text type="reference">
            Casa mediana CDMX: $4 millones de pesos; enganche de $800,000
          </Text>
        </li>
      </References>
      <Text type="reference">Visita MetrosCúbicos para mayor detalle</Text>
    </QuestionReference>
  ),
};

export const emergencyFundGoalMoneyRequired = {
  inputName: 'moneyRequired',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'Quiero juntar ',
  endText: 'pesos para mi fondo de emergencia',
  placeholder: '90,000',
  maxDigits: 10, // 10 because we want 99,999,999 to be the largest number
  inputMaxWidth: 6,
  validation: Yup.string()
    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
    .required('Este es un campo requerido'),
  reference: (
    <QuestionReference>
      <Text type="referenceTitle">Recomendación:</Text>
      <References>
        <li>
          <Text type="reference">
            En Finauta recomendamos ahorrar como mínimo 3 meses de salario para soportar alguna
            emergencia
          </Text>
        </li>
      </References>
    </QuestionReference>
  ),
};

export const educationGoalMoneyRequired = {
  inputName: 'moneyRequired',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'El posgrado que quiero, cuesta más o menos ',
  endText: 'pesos (colegiatura y costos de vida)',
  placeholder: '500,000',
  maxDigits: 10, // 10 because we want 99,999,999 to be the largest number
  inputMaxWidth: 6,
  validation: Yup.string()
    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
    .required('Este es un campo requerido'),
  reference: (
    <QuestionReference>
      <Text type="referenceTitle">Como referencia:</Text>
      <References>
        <li>
          <Text type="reference">
            Costos de vida extranjero: $28,500 USD aprox. por año en Boston, EUA
          </Text>
        </li>
        <li>
          <Text type="reference">Referencia maestría México</Text>
        </li>
      </References>
      <Text type="reference">
        Visita la página de la universidad de tu preferencia para mayor detalle sobre costos de
        colegiatura y vida
      </Text>
    </QuestionReference>
  ),
};

export const retirementGoalMoneyRequired = {
  inputName: 'moneyRequired',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'Quiero juntar ',
  endText: 'pesos para mi retiro',
  placeholder: '2,000,000',
  maxDigits: 10, // 10 because we want 99,999,999 to be the largest number
  inputMaxWidth: 6,
  validation: Yup.string()
    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
    .required('Este es un campo requerido'),
  reference: (
    <QuestionReference>
      <Text type="referenceTitle">Como referencia, una pensión a los 65 años de:</Text>
      <References>
        <li>
          <Text type="reference">$15,000 mensuales cuesta $760,000 pesos</Text>
        </li>
        <li>
          <Text type="reference">$30,000 mensuales cuesta $1,530,000 pesos</Text>
        </li>
        <li>
          <Text type="reference">$60,000 mensuales cuesta $3,050,000 pesos</Text>
        </li>
      </References>
      <Text type="reference">Solicita una asesoría financiera en línea para mayor detalle</Text>
    </QuestionReference>
  ),
};

export const weddingGoalMoneyRequired = {
  inputName: 'moneyRequired',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'La boda que quiero cuesta más o menos ',
  endText: 'pesos',
  placeholder: '150,000',
  maxDigits: 10, // 10 because we want 99,999,999 to be the largest number
  inputMaxWidth: 6,
  validation: Yup.string()
    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
    .required('Este es un campo requerido'),
  reference: (
    <QuestionReference>
      <Text type="referenceTitle">Como referencia:</Text>
      <Text type="reference">
        Una boda promedio en México cuesta entre $100,000 y $250,000 pesos (incluyendo preparativos
        y luna de miel)
      </Text>
    </QuestionReference>
  ),
};

export const customGoalMoneyRequired = {
  inputName: 'moneyRequired',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'Esta meta cuesta más o menos ',
  endText: 'pesos',
  placeholder: '100,000',
  maxDigits: 10, // 10 because we want 99,999,999 to be the largest number
  inputMaxWidth: 6,
  validation: Yup.string()
    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
    .required('Este es un campo requerido'),
  reference: <QuestionReference />,
};

// Inicia Picker de crédito
export const creditCard = [
  {
    ...inputMap.get('pays_credit_card_on_time'),
    inputName: 'pays_credit_card_on_time',
    base: true,
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,

        extraQuestions: [
          {
            inputName: 'credit_card_payment',
            type: questionTypes.NUMERIC,
            pattern: '[0-9]*',
            prepend: '$',
            startText: 'Pago ',
            endText: 'pesos al mes en tarjetas de crédito',
            placeholder: '20,000',
            maxDigits: 7, // 7 because we want 999,999 to be the largest number
            inputMaxWidth: 4,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
          {
            inputName: 'credit_card_owed',
            type: questionTypes.NUMERIC,
            pattern: '[0-9]*',
            prepend: '$',
            startText: 'Debo ',
            endText: 'de tarjetas de crédito',
            placeholder: '20,000',
            maxDigits: 7, // 7 because we want 999,999 to be the largest number
            inputMaxWidth: 4,
            validation: Yup.string()
              .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
              .required('Este es un campo requerido'),
          },
        ],
      },
    ],
  },
  {},
  // primero utilizaremos supuestos para esto
  // {
  //   inputName: 'knows_card_rate',
  //   base: true,
  //   value: null,
  //   type: questionTypes.YESNO,
  //   startText: '¿Conoces la tasa de interés de tus tarjetas de crédito?',
  //   answers: [
  //     {
  //       label: 'Sí',
  //       hotkey: 'S',
  //       value: 1,
  //       extraQuestions: [
  //         {
  //           inputName: 'card_rate',
  //           value: 0,
  //           type: questionTypes.NUMERIC,
  //           pattern: '[0-9.]*',
  //           startText: 'Mi tasa aprox. de tarjetas de crédito es ',
  //           endText: '%',
  //           maxDigits: 3, // 6 because we want 99,999 to be the largest number
  //           inputMaxWidth: 4,
  //           validation: Yup.number(),
  //         },
  //       ],
  //     },
  //     {
  //       label: 'No',
  //       hotkey: 'N',
  //       value: 0,
  //     },
  //   ],
  //   reference: <QuestionReference>
  //     <Text type="reference">Si no la sabes, no te preocupes. Usaremos un aproximado como supuesto</Text>
  //   </QuestionReference>,
  // },
];

export const carCredit = [
  {
    inputName: 'credit_car_payment',
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Pago ',
    endText: 'pesos al mes en crédito automotriz',
    placeholder: '20,000',
    maxDigits: 7, // 7 because we want 999,999 to be the largest number
    inputMaxWidth: 4,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'credit_car_owed',
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Debo ',
    endText: 'en crédito automotriz',
    placeholder: '20,000',
    maxDigits: 7, // 7 because we want 999,999 to be the largest number
    inputMaxWidth: 4,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  // primero utilizaremos supuestos para esto
  // {
  //   inputName: 'knows_car_rate',
  //   base: true,
  //   value: null,
  //   type: questionTypes.YESNO,
  //   startText: '¿Conoces la tasa de interés de tu crédito automotriz?',
  //   answers: [
  //     {
  //       label: 'Sí',
  //       hotkey: 'S',
  //       value: 1,
  //       extraQuestions: [
  //         {
  //           inputName: 'car_rate',
  //           value: 0,
  //           type: questionTypes.NUMERIC,
  //           pattern: '[0-9.]*',
  //           startText: 'Mi tasa aprox. de crédito automotriz es ',
  //           endText: '%',
  //           maxDigits: 3, // 6 because we want 99,999 to be the largest number
  //           inputMaxWidth: 4,
  //           validation: Yup.number()
  //             .required('Este es un campo requerido'),
  //         },
  //       ],
  //     },
  //     {
  //       label: 'No',
  //       hotkey: 'N',
  //       value: 0,
  //     },
  //   ],
  //   reference: <QuestionReference>
  //     <Text type="reference">Si no la sabes, no te preocupes. Usaremos un aproximado como supuesto</Text>
  //   </QuestionReference>,
  // },
];

export const mortgageCredit = [
  {
    inputName: 'credit_home_payment',
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Pago ',
    endText: 'pesos al mes en crédito hipotecario',
    placeholder: '20,000',
    maxDigits: 7, // 7 because we want 999,999 to be the largest number
    inputMaxWidth: 4,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'credit_home_owed',
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Debo ',
    endText: 'de crédito hipotecario',
    placeholder: '20,000',
    maxDigits: 7, // 7 because we want 999,999 to be the largest number
    inputMaxWidth: 4,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },

  // primero utilizaremos supuestos para esto

  // {
  //   inputName: 'knows_mortgage_rate',
  //   base: true,
  //   value: null,
  //   type: questionTypes.YESNO,
  //   startText: '¿Conoces la tasa de interés de tu crédito hipotecario?',
  //   answers: [
  //     {
  //       label: 'Sí',
  //       hotkey: 'S',
  //       value: 1,
  //       extraQuestions: [
  //         {
  //           inputName: 'mortgage_rate',
  //           value: 0,
  //           type: questionTypes.NUMERIC,
  //           pattern: '[0-9.]*',
  //           startText: 'Mi tasa aprox. de crédito hipotecario es ',
  //           endText: '%',
  //           maxDigits: 3, // 6 because we want 99,999 to be the largest number
  //           inputMaxWidth: 4,
  //           validation: Yup.number()
  //             .required('Este es un campo requerido'),
  //         },
  //       ],
  //     },
  //     {
  //       label: 'No',
  //       hotkey: 'N',
  //       value: 0,
  //     },
  //   ],
  //   reference: <QuestionReference>
  //     <Text type="reference">Si no la sabes, no te preocupes. Usaremos un aproximado como supuesto</Text>
  //   </QuestionReference>,
  // },
];

export const personalCredit = [
  {
    inputName: 'credit_personal_payment',
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Pago ',
    endText: 'pesos al mes en crédito personal',
    placeholder: '20,000',
    maxDigits: 7, // 7 because we want 999,999 to be the largest number
    inputMaxWidth: 4,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'credit_personal_owed',
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Debo ',
    endText: 'en crédito personal',
    placeholder: '20,000',
    maxDigits: 7, // 7 because we want 999,999 to be the largest number
    inputMaxWidth: 4,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  // primero utilizaremos supuestos para esto

  // {
  //   inputName: 'knows_personal_rate',
  //   base: true,
  //   value: null,
  //   type: questionTypes.YESNO,
  //   startText: '¿Conoces la tasa de interés de tu crédito personal?',
  //   answers: [
  //     {
  //       label: 'Sí',
  //       hotkey: 'S',
  //       value: 1,
  //       extraQuestions: [
  //         {
  //           inputName: 'personal_rate',
  //           value: 0,
  //           type: questionTypes.NUMERIC,
  //           pattern: '[0-9.]*',
  //           startText: 'Mi tasa aprox. de crédito personal es ',
  //           endText: '%',
  //           maxDigits: 3, // 6 because we want 99,999 to be the largest number
  //           inputMaxWidth: 4,
  //           validation: Yup.number()
  //             .required('Este es un campo requerido'),
  //         },
  //       ],
  //     },
  //     {
  //       label: 'No',
  //       hotkey: 'N',
  //       value: 0,
  //     },
  //   ],
  //   reference: <QuestionReference>
  //     <Text type="reference">Si no la sabes, no te preocupes. Usaremos un aproximado como supuesto</Text>
  //   </QuestionReference>,
  // },
];

export const studentCredit = [
  {
    inputName: 'credit_school_payment',
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Pago ',
    endText: 'pesos al mes en crédito estudiantil',
    placeholder: '20,000',
    maxDigits: 7, // 7 because we want 999,999 to be the largest number
    inputMaxWidth: 4,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'student_credit_owed',
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Debo ',
    endText: 'en crédito estudiantil',
    placeholder: '20,000',
    maxDigits: 7, // 7 because we want 999,999 to be the largest number
    inputMaxWidth: 4,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
  },
  // primero utilizaremos supuestos para esto

  // {
  //   inputName: 'knows_student_rate',
  //   base: true,
  //   value: null,
  //   type: questionTypes.YESNO,
  //   startText: '¿Conoces la tasa de interés de tu crédito estudiantil?',
  //   answers: [
  //     {
  //       label: 'Sí',
  //       hotkey: 'S',
  //       value: 1,
  //       extraQuestions: [
  //         {
  //           inputName: 'student_rate',
  //           value: 0,
  //           type: questionTypes.NUMERIC,
  //           pattern: '[0-9.]*',
  //           startText: 'Mi tasa aprox. de crédito estudiantil es ',
  //           endText: '%',
  //           maxDigits: 3, // 6 because we want 99,999 to be the largest number
  //           inputMaxWidth: 4,
  //           validation: Yup.number()
  //             .required('Este es un campo requerido'),
  //         },
  //       ],
  //     },
  //     {
  //       label: 'No',
  //       hotkey: 'N',
  //       value: 0,
  //     },
  //   ],
  //   reference: <QuestionReference>
  //     <Text type="reference">Si no la sabes, no te preocupes. Usaremos un aproximado como supuesto</Text>
  //   </QuestionReference>,
  // },
];

export const otherCredit = [
  // primero utilizaremos supuestos para esto
  // {
  //   inputName: 'knows_other_rate',
  //   base: true,
  //   value: null,
  //   type: questionTypes.YESNO,
  //   startText: '¿Conoces la tasa de interés de tus otros créditos?',
  //   answers: [
  //     {
  //       label: 'Sí',
  //       hotkey: 'S',
  //       value: 1,
  //       extraQuestions: [
  //         {
  //           inputName: 'other_rate',
  //           value: 0,
  //           type: questionTypes.NUMERIC,
  //           pattern: '[0-9.]*',
  //           startText: 'Mi tasa aprox. de otros créditos es ',
  //           endText: '%',
  //           maxDigits: 3, // 6 because we want 99,999 to be the largest number
  //           inputMaxWidth: 4,
  //           validation: Yup.number()
  //             .required('Este es un campo requerido'),
  //         },
  //       ],
  //     },
  //     {
  //       label: 'No',
  //       hotkey: 'N',
  //       value: 0,
  //     },
  //   ],
  //   reference: <QuestionReference>
  //     <Text type="reference">Si no la sabes, no te preocupes. Usaremos un aproximado como supuesto</Text>
  //   </QuestionReference>,
  // },
];
// Termina Picker de crédito

export const firstQuestion = [
  {
    inputName: 'age',
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Tengo ',
    endText: 'años',
    placeholder: '',
    maxDigits: 3,
    inputMaxWidth: 2,
    validation: Yup.number()
      .moreThan(17, 'Tienes que ser mayor de edad')
      .lessThan(99, 'Te recomendamos no ahorrar a esta edad')
      .required('Este es un campo requerido'),
  },
];

export const lastQuestion = [
  {
    inputName: 'initialSavings',
    final: '→ Obtener plan',
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    prepend: '$',
    startText: 'Quiero que mi plan considere ',
    endText: 'de mis ahorros',
    placeholder: '0',
    maxDigits: 10, // 10 because we want 99,999,999 to be the largest number
    inputMaxWidth: 6,
    validation: Yup.string()
      .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
      .required('Este es un campo requerido'),
    reference: (
      <QuestionReference>
        <Text type="reference">Esta información nos ayudará a calcular tu plan personalizado</Text>
      </QuestionReference>
    ),
  },
];

// QUESTIONS FOR THE RETIRMENT

// First question has already been implemented

// Ingreso actual
export const monthlyWageAfterTaxes = {
  base: true,
  inputName: 'monthly_wage_after_taxes',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'Mi ingreso mensual después de impuestos es de ',
  endText: 'pesos al mes',
  placeholder: '15,000',
  maxDigits: 7, // 7 because we want 999,999 to be the largest number
  inputMaxWidth: 4,
  validation: Yup.string()
    .matches(/^[1-9]+(?:,[0-9]+)*(?:\.[0-9]+)?/, 'Debe ser mayor que cero')
    .required('Este es un campo requerido'),
  reference: (
    <QuestionReference>
      <Text type="reference">
        <Icon icon="lock" style={{ marginRight: '3px' }} color={palette.darkerGray} size={8} />
        <b>Información anónima</b>. Sólo usaremos esta información para calcular tu retiro
      </Text>
    </QuestionReference>
  ),
};

// Ahorro a afore mensual
export const monthlyContributionToAFORE = {
  inputName: 'monthlyContributionToAFORE',
  value: 6.5,
  type: questionTypes.NUMERIC,
  pattern: '[0-9.]*',
  startText: 'Cada mes abono ',
  endText: '% de mi salario a mi Afore',
  placeholder: '6.5',
  maxDigits: 4, // 6 because we want 99,999 to be the largest number
  inputMaxWidth: 2,
  validation: Yup.number()
    .required('Este es un campo requerido')
    .lessThan(101, 'Máximo podrás ahorrar el 100% de tu salario')
    .moreThan(-1, 'Debe ser mayor o igual a cero'),
  reference: (
    <QuestionReference>
      <Text type="reference">
        Por ley, cada mes se abona el
        <b> 6.5% </b>
        de tu salario a tu Afore. El porcentaje será mayor si realizas aportaciones complementarias.
      </Text>
    </QuestionReference>
  ),
};

export const phoneNumberRetirement = {
  base: true,
  inputName: 'phone_number',
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  startText: 'Mi número de teléfono es ',
  placeholder: 'Tu número de teléfono',
  maxDigits: 12, // 10 because we want 99,999,999 to be the largest number
  inputMaxWidth: 8,
  noThousandSeparator: true,
  validation: Yup.string().required('Este es un campo requerido'),
  reference: (
    <QuestionReference>
      <Text type="reference">Esta información te ayudará a consultar los datos de tu retiro</Text>
    </QuestionReference>
  ),
};

// Current savings in AFORE for retirement
export const currentAFORESavings = {
  base: true,
  inputName: 'currentAFORESavings',
  final: '→ Obtener resultados',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'Tengo ahorrado en mi Afore aprox. ',
  endText: 'pesos',
  placeholder: '0',
  maxDigits: 10, // 10 because we want 99,999,999 to be the largest number
  inputMaxWidth: 6,
  validation: Yup.string()
    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
    .required('Este es un campo requerido'),
  reference: (
    <QuestionReference>
      <Text type="reference">Esta información nos ayudará a calcular tu retiro</Text>
    </QuestionReference>
  ),
};

export const FAKE_RESPONSE_RETIREMENT_CONTRIBUTES = {
  _id: '5cad475a92a2562628c99086',
  age: 22,
  current_AFORE_savings: 100000,
  contribution_amount: 858,
  contributes: true,
  monthly_wage_after_taxes: 20000,
  other_expected_income: 0,
  retirement_age: 65,
  life_expectancy: 90,
  anual_rate_of_return_during_savings: 0.07,
  anual_rate_of_return_during_retirement: 0.05,
  anual_growth_in_monthly_contributions: 0.03,
  anual_growth_in_retirement_income: 0.03,
  anual_growth_in_income: 0.03,
  monthly_contribution_to_AFORE: 2158,
  current_scenario: {
    _id: '5cad475a92a2562628c99087',
    pv_retiro_mensual: 14001.018022252338,
    tasa_de_remplazo: 0.7000509011126169,
    ahorro_mensual: 2158,
  },
  objective_scenario: {
    _id: '5cad475a92a2562628c99088',
    pv_retiro_mensual: 13999.999999999998,
    tasa_de_remplazo: 0.7,
    ahorro_mensual: 2157.8144828380046,
  },
  __v: 0,
};

export const FAKE_RESPONSE_RETIREMENT_NOT_CONTRIBUTES = {
  _id: '5cad4c2892a2562628c99090',
  age: 22,
  current_AFORE_savings: 100000,
  contribution_amount: 0,
  contributes: false,
  monthly_wage_after_taxes: 20000,
  other_expected_income: 0,
  retirement_age: 65,
  life_expectancy: 90,
  anual_rate_of_return_during_savings: 0.07,
  anual_rate_of_return_during_retirement: 0.05,
  anual_growth_in_monthly_contributions: 0.03,
  anual_growth_in_retirement_income: 0.03,
  anual_growth_in_income: 0.03,
  monthly_contribution_to_AFORE: 1300,
  current_scenario: {
    _id: '5cad4c2892a2562628c99091',
    pv_retiro_mensual: 9292.757702216262,
    tasa_de_remplazo: 0.46463788511081316,
    ahorro_mensual: 1300,
  },
  objective_scenario: {
    _id: '5cad4c2892a2562628c99092',
    pv_retiro_mensual: 13999.999999999998,
    tasa_de_remplazo: 0.7,
    ahorro_mensual: 2157.8144828380046,
  },
  __v: 0,
};

export const FAKE_RESPONSE = {
  _id: '5c41068136c973002418b895',
  age: 21,
  current_savings: 200000,
  financial_goals: [
    {
      late: {
        bank: {
          years: 3,
          months: 3,
        },
      },
      _id: '5c41068136c973002418b899',
      name: 'Option_1',
      money_required: 500000,
      years_to_expense: 1,
      money_to_save: 32834.253810642294,
      months_to_save: 12,
    },
    {
      late: {
        bank: {
          years: 0,
          months: 10,
        },
      },
      _id: '5c41068136c973002418b898',
      name: 'Option_2',
      money_required: 300000,
      years_to_expense: 3,
      money_to_save: 32834.253810642294,
      months_to_save: 24,
    },
    {
      late: {
        bank: {
          years: 2,
          months: 7,
        },
      },
      _id: '5c41068136c973002418b897',
      name: 'Option_3',
      money_required: 4000000,
      years_to_expense: 10,
      money_to_save: 32834.253810642294,
      months_to_save: 84,
    },
    {
      late: {
        bank: {
          years: 10,
          months: 11,
        },
      },
      _id: '5c41068136c973002418b896',
      name: 'Option_4',
      money_required: 2000000,
      years_to_expense: 25,
      money_to_save: 8223.844521789597,
    },
  ],
  savings_periods: [
    {
      _id: '5c41068136c973002418b89a',
      money: 32834.253810642294,
      from_month: 0,
      to_month: 120,
    },
    {
      _id: '5c41068136c973002418b89b',
      money: 8223.844521789597,
      from_month: 120,
      to_month: 300,
    },
  ],
  __v: 0,
};

export const FAKE_RESPONSE_SAVINGS = {
  monthly_contribution: 2000,
  years_to_save: 10,
  annual_interest_rate: 4,
  current_savings: 100000,
  adjusted_contribution: 0,
};

export const FAKE_RESPONSE_DEBT = {
  original_monthly_payment: [
    13496.672534868898,
    7598.457886691503,
    5673.650900726933,
    4741.168087167247,
  ],
  finauta_monthly_payment: [
    12356.594900070588,
    6484.415412795617,
    4533.424042420867,
    3562.7061850267296,
  ],
  monthly_savings: [1140.07763479831, 1114.0424738958855, 1140.2268583060659, 1178.4619021405174],
  total_savings: [6840.465808789861, 13368.509686750625, 20524.083449509184, 28283.085651372417],
  original_total_interests: [
    10980.035209213383,
    21181.494640298028,
    32125.7162130848,
    43788.03409201393,
  ],
  finauta_total_interests: [
    4139.5694004235265,
    7812.984953547406,
    11601.632763575617,
    15504.948440641514,
  ],
  payment_periods_options: [6, 12, 18, 24],
  payment_periods_index: 2,
  _id: '5c9b99ed0924bf42cc0e24b7',
  debt_1: 50000,
  bank_1: 'banamex',
  type_of_card_1: 'travel_pass',
  add_card_1: true,
  debt_2: 20000,
  bank_2: 'invex',
  type_of_card_2: 'volaris_clasica',
  payment_periods: 24,
  original_weighted_annual_interest: 0.5428571428571429,
  finauta_annual_interest: 0.2,
  __v: 0,
};

export const FAKE_RESPONSE_SHORT = {
  _id: '5c41068136c973002418b895',
  age: 25,
  current_savings: 0,
  financial_goals: [
    {
      late: {
        bank: {
          years: 5,
          months: 5,
        },
      },
      _id: '5c41068136c973002418b899',
      name: 'Option_1',
      money_required: 500000,
      years_to_expense: 1,
      money_to_save: 8999999,
      months_to_save: 168,
    },
  ],
  savings_periods: [
    {
      _id: '5c41068136c973002418b89a',
      money: 899,
      from_month: 0,
      to_month: 168,
    },
  ],
  __v: 0,
};

export const FAKE_RESPONSE_BIG_FISH = {
  _id: '5c81e59dcdba511539898ebe',
  age: 55,
  current_savings: 7,
  financial_goals: [
    {
      _id: '5c81e59dcdba511539898ebf',
      name: 'Auto',
      money_required: 6,
      years_to_expense: 1,
      money_to_save: 0,
      months_to_save: 0,
    },
  ],
  savings_periods: [],
  __v: 0,
};

export const HowManyWeeks = {
  inputName: 'weeks_worked',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  startText: 'Llevo ',
  endText: ' semanas cotizadas',
  placeholder: '',
  maxDigits: 5,
  inputMaxWidth: 5,
  validation: Yup.string()
    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
    .required('Este es un campo requerido'),
};

export const HowManyYears = {
  inputName: 'years_worked_73',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  startText: 'He trabajado aprox ',
  endText: ' años en un empleo formal',
  placeholder: '5',
  maxDigits: 2,
  inputMaxWidth: 2,
  validation: Yup.number().required('Este es un campo requerido'),
};

export const HowManyUnderAgeChildren = {
  inputName: 'under_age_children',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  startText: 'Cuando me pensione, ',
  endText: ' de mis hijos seguirán siendo menores de edad',
  placeholder: '1',
  maxDigits: 2,
  inputMaxWidth: 2,
  validation: Yup.number().required('Este es un campo requerido'),
};

export const HowManyAliveParents = {
  inputName: 'alive_parents',
  value: null,
  type: questionTypes.YESNO,
  startText: '¿Cuántos de tus padres viven?',
  answers: [
    {
      label: '2',
      value: 2,
    },
    {
      label: '1',
      value: 1,
    },
    {
      label: '0',
      value: 0,
    },
  ],
};

export const FindOutHasChildren = {
  inputName: 'has_children',
  value: null,
  ...inputMap.get('has_children'),
  answers: [
    {
      label: 'Sí',
      hotkey: 'S',
      value: 1,
      extraQuestions: [HowManyUnderAgeChildren],
    },
    {
      label: 'No',
      hotkey: 'N',
      value: 0,
      extraQuestions: [HowManyAliveParents],
    },
  ],
};

export const CivilStatus = (askForChildren) => ({
  inputName: 'civil_status',
  label: 'Mi estado civil es...',
  type: questionTypes.YESNO,
  startText: 'Mi estado civil es...',
  answers: [
    {
      label: 'Casado',
      value: 0,
      extraQuestions: askForChildren && [FindOutHasChildren],
    },
    {
      label: 'Soltero',
      value: 1,
      extraQuestions: askForChildren && [FindOutHasChildren],
    },
    {
      label: 'Viudo',
      value: 2,
      extraQuestions: askForChildren && [FindOutHasChildren],
    },
    {
      label: 'Divorciado',
      value: 3,
      extraQuestions: askForChildren && [FindOutHasChildren],
    },
  ],
});

export const FindOutWeeks = {
  inputName: 'knows_weeks_worked',
  value: null,
  type: questionTypes.YESNO,
  startText: '¿Sabes cuántas semanas has cotizado?',
  answers: [
    {
      label: 'Sí',
      hotkey: 'S',
      value: 1,
      extraQuestions: [HowManyWeeks],
    },
    {
      label: 'No',
      hotkey: 'N',
      value: 0,
      extraQuestions: [HowManyYears],
    },
  ],
};

export const MonthlyWageAfterTaxesLastFiveYears = {
  base: true,
  inputName: 'monthly_wage_after_taxes_last_five_years',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'En promedio, en los últimos 5 años he estado ganando después de impuestos',
  endText: 'pesos al mes',
  placeholder: '8,000',
  maxDigits: 7, // 7 because we want 999,999 to be the largest number
  inputMaxWidth: 4,
  validation: Yup.string()
    .matches(/^\d{1,3}(,\d{3})*(\.\d+)?$/, 'Debe ser mayor o igual a cero')
    .required('Este es un campo requerido'),
  reference: (
    <QuestionReference>
      <Text type="reference">
        <Icon icon="lock" style={{ marginRight: '3px' }} color={palette.darkerGray} size={8} />
        <b>Información anónima</b>. Sólo usaremos esta información para calcular tu retiro
      </Text>
    </QuestionReference>
  ),
};

const Disclaimer = (askForChildren) => ({
  inputName: 'disclaimer',
  label: '¡No te preocupes! Usaremos tu salario mensual después de impuestos',
  type: questionTypes.YESNO,
  startText: '¡No te preocupes! Usaremos tu salario mensual después de impuestos',
  answers: [
    {
      label: 'Entendido',
      value: 1,
      extraQuestions: [CivilStatus(askForChildren)],
    },
  ],
  reference: (
    <QuestionReference>
      <Text type="warningMessage">
        Ojo, hay empresas que dan de alta a sus empleados con un salario de cotización menor a su
        ingreso. Si este es tu caso, tu pensión real será menor a la estimada.
      </Text>
      <Text type="reference">
        Puedes descargar un reporte con tus semanas cotizadas y tu salario base de cotización diario{' '}
        <a target="_blank" href="">
          aquí
        </a>
      </Text>
    </QuestionReference>
  ),
});

const SalarioBaseDeCotizacionDiario = {
  inputName: 'salario_base_de_cotizacion_diario',
  value: null,
  type: questionTypes.NUMERIC,
  pattern: '[0-9]*',
  prepend: '$',
  startText: 'Mi salario base de cotización diario es de ',
  endText: 'pesos al día',
  placeholder: '500',
  maxDigits: 7, // 7 because we want 999,999 to be the largest number
  inputMaxWidth: 4,
  validation: Yup.number()
    .moreThan(0, 'Debe ser mayor que cero')
    .lessThan(
      2200,
      'El salario máximo de cotización diario es de 25 UMA ($2,112.25 pesos en el 2019)',
    )
    .required('Este es un campo requerido'),
  noThousandSeparator: true,
};

const KnowsSalarioBaseDeCotizacionDiario = (askForChildren) => ({
  inputName: 'knows_salario_base_de_cotizacion_diario',
  label: '¿Conoces tu salario de cotización diario?',
  type: questionTypes.YESNO,
  startText: '¿Conoces tu salario de cotización diario?',
  answers: [
    {
      label: 'Si',
      value: 1,
      extraQuestions: [SalarioBaseDeCotizacionDiario, CivilStatus(askForChildren)],
    },
    {
      label: 'No',
      value: 0,
      extraQuestions: [Disclaimer(askForChildren)],
    },
  ],
});

export const FirstFormalJob = (askForChildren) => ({
  inputName: 'started_working_before_97',
  label: 'Empezaste a trabajar después de 1997',
  type: questionTypes.YESNO,
  startText: 'Mi primer trabajo formal fue...',
  answers: [
    {
      label: 'Antes del 97',
      value: 1,
      extraQuestions: [FindOutWeeks, KnowsSalarioBaseDeCotizacionDiario(askForChildren)],
    },
    {
      label: 'En el 97',
      value: 2,
      extraQuestions: [FindOutWeeks, KnowsSalarioBaseDeCotizacionDiario(askForChildren)],
    },
    {
      label: 'Después del 97',
      value: 0,
      extraQuestions: [currentAFORE],
    },
  ],
});

const RetirementHasSocialSecurity = (askForChildren) => ({
  inputName: 'has_social_security',
  value: null,
  base: true,
  ...inputMap.get('has_social_security'),
  answers: [
    {
      label: 'Sí',
      value: 1,
      extraQuestions: [FirstFormalJob(askForChildren)],
    },
    {
      label: 'No',
      value: 0,
      extraQuestions: [hasPPR],
    },
    {
      label: 'No sé',
      value: 2,
      extraQuestions: [
        {
          inputName: 'has_salary_recipts',
          ...inputMap.get('has_salary_recipts'),
          answers: [
            {
              label: 'Sí',
              hotkey: 'S',
              value: 1,
              extraQuestions: [FirstFormalJob(askForChildren)],
            },
            {
              label: 'No',
              hotkey: 'N',
              value: 0,
              extraQuestions: [hasPPR],
            },
          ],
        },
      ],
    },
  ],
});

export const RetirementQuestionnaire = [
  {
    base: true,
    inputName: 'age',
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    startText: 'Tengo ',
    endText: 'años',
    placeholder: '',
    maxDigits: 2,
    inputMaxWidth: 2,
    validation: Yup.number()
      .moreThan(17, 'Tienes que ser mayor de edad')
      .lessThan(65, 'Esperamos que a esta edad ya te encuentres retirado')
      .required('Este es un campo requerido'),
  },
  monthlyWageAfterTaxes,
  RetirementHasSocialSecurity(true),
  {
    inputName: 'email',
    base: true,
    endText: '',
    startText: 'Última pregunta: ¿A qué correo electrónico quieres que mandemos tus resultados?',
    label: 'Última pregunta: ¿A qué correo electrónico quieres que mandemos tus resultados?',
    type: questionTypes.NUMERIC,
    isTextual: true,
    placeholder: 'tucorreo@ejemplo.com',
    maxDigits: 80,
    inputSpanWidth: 20,
    inputWidth: '250px',
    inputMaxWidth: 100,
    validation: Yup.string()
      .email('Debe ser un correo electrónico válido')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'getQuoteQuestion',
    label: '¡Todo listo!',
    type: questionTypes.YESNO,
    startText: '¡Todo listo!',
    answers: [],
    disclaimer: (
      <QuestionReference>
        <Text type="reference" styles={{ marginTop: '10px' }}>
          Al dar click en "Obtener cálculo" estás aceptando los{' '}
          <a target="_blank" href="https://www.finauta.com/terminos">
            términos y condiciones
          </a>{' '}
          y el{' '}
          <a target="_blank" href="https://www.finauta.com/aviso">
            aviso de privacidad
          </a>{' '}
          de Finauta.
        </Text>
      </QuestionReference>
    ),
    final: '→ Obtener cálculo',
  },
];

// Primera sección
export const personalInfo = [
  {
    inputName: 'age',
    base: true,
    value: null,
    type: questionTypes.NUMERIC,
    pattern: '[0-9]*',
    ...inputMap.get('age'),
    placeholder: '',
    maxDigits: 2,
    inputMaxWidth: 2,
    validation: Yup.number()
      .moreThan(17, 'Tienes que ser mayor de edad')
      .lessThan(65, 'Tu edad debe ser menor a 65 años')
      .required('Este es un campo requerido'),
  },
  {
    inputName: 'sex',
    value: null,
    base: true,
    ...inputMap.get('sex'),
    reference: (
      <QuestionReference>
        <Text type="reference">Esto nos ayudará a estimar el costo de posibles seguros</Text>
      </QuestionReference>
    ),
    answers: [
      {
        label: 'Mujer',
        value: 0,
      },
      {
        label: 'Hombre',
        value: 1,
      },
      {
        label: 'Otro',
        value: 2,
      },
    ],
  },
  RetirementHasSocialSecurity(false),
  {
    inputName: 'has_children',
    value: null,
    ...inputMap.get('has_children'),
    answers: [
      {
        label: 'Sí',
        hotkey: 'S',
        value: 1,
      },
      {
        label: 'No',
        hotkey: 'N',
        value: 0,
      },
    ],
  },
];
